var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHeroImg(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 1489.284,
    height: 918.294,
    viewBox: "0 0 1489.284 918.294",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "hero-img",
    transform: "translate(-17.629 -25.049)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Background_Complete",
    "data-name": "Background Complete",
    transform: "translate(66.887 25.049)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_83",
    "data-name": "Group 83",
    transform: "translate(0 97.599)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6",
    "data-name": "Group 6",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2",
    "data-name": "Group 2",
    transform: "translate(0.823 0.85)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1",
    "data-name": "Group 1"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1",
    "data-name": "Rectangle 1",
    width: 308.025,
    height: 284.614,
    fill: "#fafafa"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5",
    "data-name": "Group 5"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4",
    "data-name": "Group 4"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3",
    "data-name": "Group 3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1",
    "data-name": "Path 1",
    d: "M350.076,355.785s-.052-1.826-.079-5.284c-.019-3.492-.044-8.6-.079-15.248-.042-13.364-.1-32.9-.182-57.774-.086-49.729-.211-120.787-.359-206.309l.7.722-307.995.129h-.029l.825-.852c-.038,103.547-.071,200.984-.1,284.615l-.724-.75,222.786.379,62.836.2,16.634.088,4.29.043c.966.013,1.48.043,1.48.043s-.457.028-1.4.043l-4.212.041c-3.774.022-9.3.05-16.492.088l-62.674.2c-54.1.09-131.169.22-223.251.377l-.724,0v-.75c-.029-83.631-.063-181.068-.1-284.615v-.849h.852c113.42.047,219.288.091,307.995.129h.7l0,.72c-.148,85.712-.271,156.927-.359,206.766-.077,24.809-.14,44.287-.182,57.61-.035,6.593-.06,11.652-.079,15.112C350.126,354.067,350.076,355.785,350.076,355.785Z",
    transform: "translate(-41.227 -70.321)",
    fill: "#e0e0e0"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_9",
    "data-name": "Group 9",
    transform: "translate(46.511 50.569)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8",
    "data-name": "Group 8"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7",
    "data-name": "Group 7"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2",
    "data-name": "Path 2",
    d: "M135.929,94.63c0,.468-16.213.849-36.208.849S63.509,95.1,63.509,94.63s16.208-.852,36.212-.852S135.929,94.16,135.929,94.63Z",
    transform: "translate(-63.509 -93.778)",
    fill: "#e0e0e0"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_12",
    "data-name": "Group 12",
    transform: "translate(50.49 71.94)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11",
    "data-name": "Group 11"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10",
    "data-name": "Group 10"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3",
    "data-name": "Path 3",
    d: "M264.371,104.54c0,.47-44.543.852-99.474.852-54.95,0-99.482-.382-99.482-.852s44.532-.849,99.482-.849C219.829,103.691,264.371,104.073,264.371,104.54Z",
    transform: "translate(-65.415 -103.691)",
    fill: "#e0e0e0"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_14",
    "data-name": "Group 14",
    transform: "translate(47.041 108.989)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_13",
    "data-name": "Group 13"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2",
    "data-name": "Rectangle 2",
    width: 12.978,
    height: 13.403,
    fill: "#e0e0e0"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_16",
    "data-name": "Group 16",
    transform: "translate(78.985 108.989)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15",
    "data-name": "Group 15"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3",
    "data-name": "Rectangle 3",
    width: 12.977,
    height: 13.403,
    fill: "#e0e0e0"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_18",
    "data-name": "Group 18",
    transform: "translate(111.518 108.381)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_17",
    "data-name": "Group 17"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4",
    "data-name": "Rectangle 4",
    width: 12.977,
    height: 13.402,
    fill: "#e0e0e0"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_20",
    "data-name": "Group 20",
    transform: "translate(142.872 108.989)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_19",
    "data-name": "Group 19"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5",
    "data-name": "Rectangle 5",
    width: 12.977,
    height: 13.403,
    fill: "#e0e0e0"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_22",
    "data-name": "Group 22",
    transform: "translate(174.815 108.989)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_21",
    "data-name": "Group 21"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6",
    "data-name": "Rectangle 6",
    width: 12.977,
    height: 13.403,
    fill: "#e0e0e0"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_24",
    "data-name": "Group 24",
    transform: "translate(206.759 108.989)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_23",
    "data-name": "Group 23"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7",
    "data-name": "Rectangle 7",
    width: 12.977,
    height: 13.403,
    fill: "#e0e0e0"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_26",
    "data-name": "Group 26",
    transform: "translate(238.702 108.989)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25",
    "data-name": "Group 25"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_8",
    "data-name": "Rectangle 8",
    width: 12.977,
    height: 13.403,
    fill: "#ebebeb"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_28",
    "data-name": "Group 28",
    transform: "translate(47.041 137.482)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_27",
    "data-name": "Group 27"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_9",
    "data-name": "Rectangle 9",
    width: 12.978,
    height: 13.402,
    fill: "#ebebeb"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_30",
    "data-name": "Group 30",
    transform: "translate(78.985 137.482)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_29",
    "data-name": "Group 29"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_10",
    "data-name": "Rectangle 10",
    width: 12.977,
    height: 13.402,
    fill: "#e0e0e0"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_32",
    "data-name": "Group 32",
    transform: "translate(110.928 137.482)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_31",
    "data-name": "Group 31"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_11",
    "data-name": "Rectangle 11",
    width: 12.977,
    height: 13.402,
    fill: "#ebebeb"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_34",
    "data-name": "Group 34",
    transform: "translate(142.872 137.482)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_33",
    "data-name": "Group 33"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_12",
    "data-name": "Rectangle 12",
    width: 12.977,
    height: 13.402,
    fill: "#e0e0e0"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_36",
    "data-name": "Group 36",
    transform: "translate(174.815 137.482)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_35",
    "data-name": "Group 35"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_13",
    "data-name": "Rectangle 13",
    width: 12.977,
    height: 13.402,
    fill: "#e0e0e0"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_38",
    "data-name": "Group 38",
    transform: "translate(207.348 136.874)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_37",
    "data-name": "Group 37"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_14",
    "data-name": "Rectangle 14",
    width: 12.977,
    height: 13.403,
    fill: "#e0e0e0"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_40",
    "data-name": "Group 40",
    transform: "translate(238.702 137.482)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_39",
    "data-name": "Group 39"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_15",
    "data-name": "Rectangle 15",
    width: 12.977,
    height: 13.402,
    fill: "#e0e0e0"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_42",
    "data-name": "Group 42",
    transform: "translate(47.041 165.975)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_41",
    "data-name": "Group 41"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_16",
    "data-name": "Rectangle 16",
    width: 12.978,
    height: 13.403,
    fill: "#e0e0e0"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_44",
    "data-name": "Group 44",
    transform: "translate(79.574 165.367)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_43",
    "data-name": "Group 43"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_17",
    "data-name": "Rectangle 17",
    width: 12.977,
    height: 13.403,
    fill: "#e0e0e0"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_46",
    "data-name": "Group 46",
    transform: "translate(110.928 165.975)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_45",
    "data-name": "Group 45"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_18",
    "data-name": "Rectangle 18",
    width: 12.977,
    height: 13.403,
    fill: "#e0e0e0"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_48",
    "data-name": "Group 48",
    transform: "translate(142.872 165.975)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_47",
    "data-name": "Group 47"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_19",
    "data-name": "Rectangle 19",
    width: 12.977,
    height: 13.403,
    fill: "#ebebeb"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_50",
    "data-name": "Group 50",
    transform: "translate(174.815 165.975)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_49",
    "data-name": "Group 49"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_20",
    "data-name": "Rectangle 20",
    width: 12.977,
    height: 13.403,
    fill: "#e0e0e0"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_52",
    "data-name": "Group 52",
    transform: "translate(206.759 165.975)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_51",
    "data-name": "Group 51"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_21",
    "data-name": "Rectangle 21",
    width: 12.977,
    height: 13.403,
    fill: "#e0e0e0"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_54",
    "data-name": "Group 54",
    transform: "translate(238.702 165.975)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_53",
    "data-name": "Group 53"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_22",
    "data-name": "Rectangle 22",
    width: 12.977,
    height: 13.403,
    fill: "#e0e0e0"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_56",
    "data-name": "Group 56",
    transform: "translate(47.041 194.468)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_55",
    "data-name": "Group 55"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_23",
    "data-name": "Rectangle 23",
    width: 12.978,
    height: 13.403,
    fill: "#e0e0e0"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_58",
    "data-name": "Group 58",
    transform: "translate(78.985 194.468)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_57",
    "data-name": "Group 57"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24",
    "data-name": "Rectangle 24",
    width: 12.977,
    height: 13.403,
    fill: "#e0e0e0"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_60",
    "data-name": "Group 60",
    transform: "translate(110.928 194.468)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_59",
    "data-name": "Group 59"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25",
    "data-name": "Rectangle 25",
    width: 12.977,
    height: 13.403,
    fill: "#e0e0e0"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_62",
    "data-name": "Group 62",
    transform: "translate(143.461 193.86)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_61",
    "data-name": "Group 61"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_26",
    "data-name": "Rectangle 26",
    width: 12.977,
    height: 13.403,
    fill: "#e0e0e0"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_64",
    "data-name": "Group 64",
    transform: "translate(174.815 194.468)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63",
    "data-name": "Group 63"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_27",
    "data-name": "Rectangle 27",
    width: 12.977,
    height: 13.403,
    fill: "#e0e0e0"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_66",
    "data-name": "Group 66",
    transform: "translate(206.759 194.468)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_65",
    "data-name": "Group 65"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_28",
    "data-name": "Rectangle 28",
    width: 12.977,
    height: 13.403,
    fill: "#ebebeb"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_68",
    "data-name": "Group 68",
    transform: "translate(238.702 194.468)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_67",
    "data-name": "Group 67"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_29",
    "data-name": "Rectangle 29",
    width: 12.977,
    height: 13.403,
    fill: "#e0e0e0"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_70",
    "data-name": "Group 70",
    transform: "translate(47.041 222.961)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_69",
    "data-name": "Group 69"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_30",
    "data-name": "Rectangle 30",
    width: 12.978,
    height: 13.403,
    fill: "#e0e0e0"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_72",
    "data-name": "Group 72",
    transform: "translate(78.985 222.961)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_71",
    "data-name": "Group 71"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_31",
    "data-name": "Rectangle 31",
    width: 12.977,
    height: 13.403,
    fill: "#ebebeb"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_74",
    "data-name": "Group 74",
    transform: "translate(110.928 222.961)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_73",
    "data-name": "Group 73"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_32",
    "data-name": "Rectangle 32",
    width: 12.977,
    height: 13.403,
    fill: "#e0e0e0"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_76",
    "data-name": "Group 76",
    transform: "translate(142.872 222.961)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_75",
    "data-name": "Group 75"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_33",
    "data-name": "Rectangle 33",
    width: 12.977,
    height: 13.403,
    fill: "#e0e0e0"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_78",
    "data-name": "Group 78",
    transform: "translate(174.815 222.961)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_77",
    "data-name": "Group 77"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_34",
    "data-name": "Rectangle 34",
    width: 12.977,
    height: 13.403,
    fill: "#e0e0e0"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_80",
    "data-name": "Group 80",
    transform: "translate(207.348 222.353)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_79",
    "data-name": "Group 79"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_35",
    "data-name": "Rectangle 35",
    width: 12.977,
    height: 13.402,
    fill: "#e0e0e0"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_82",
    "data-name": "Group 82",
    transform: "translate(238.702 222.961)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_81",
    "data-name": "Group 81"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_36",
    "data-name": "Rectangle 36",
    width: 12.977,
    height: 13.403,
    fill: "#e0e0e0"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_92",
    "data-name": "Group 92",
    transform: "translate(1185.98 123.514)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_84",
    "data-name": "Group 84",
    transform: "translate(217.782 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_37",
    "data-name": "Rectangle 37",
    width: 14.843,
    height: 329.599,
    fill: "#e0e0e0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_85",
    "data-name": "Group 85",
    transform: "translate(2.469 2.549)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_38",
    "data-name": "Rectangle 38",
    d: "M.1,0H212.955a.1.1,0,0,1,.1.1v327.3a.1.1,0,0,1-.1.1H.1a.1.1,0,0,1-.1-.1V.1A.1.1,0,0,1,.1,0Z",
    fill: "#f5f5f5"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_87",
    "data-name": "Group 87"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_86",
    "data-name": "Group 86"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4",
    "data-name": "Path 4",
    d: "M827.176,414.95H609.609a.218.218,0,0,1-.215-.222V82.564a.218.218,0,0,1,.215-.222H827.176a.218.218,0,0,1,.213.222V414.728A.218.218,0,0,1,827.176,414.95Zm-212.631-5.1H822.238a.217.217,0,0,0,.213-.222V87.663a.217.217,0,0,0-.213-.222H614.546a.218.218,0,0,0-.215.222V409.63A.218.218,0,0,0,614.546,409.852Z",
    transform: "translate(-609.394 -82.342)",
    fill: "#ebebeb"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_88",
    "data-name": "Group 88",
    transform: "translate(23.921 22.754)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_39",
    "data-name": "Rectangle 39",
    d: "M.1,0H170.426a.1.1,0,0,1,.1.1V286.781a.1.1,0,0,1-.1.1H.1a.1.1,0,0,1-.1-.1V.1A.1.1,0,0,1,.1,0Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_89",
    "data-name": "Group 89",
    transform: "translate(61.123 104.085)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_40",
    "data-name": "Rectangle 40",
    width: 95.75,
    height: 115.907,
    rx: 0.064,
    fill: "#ebebeb"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_91",
    "data-name": "Group 91",
    transform: "translate(62.737 114.448)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_90",
    "data-name": "Group 90"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5",
    "data-name": "Path 5",
    d: "M726.006,226.788c.123.373-4.6,2.509-13.593,1.421a32.579,32.579,0,0,1-15.282-6.308,32.129,32.129,0,0,1-11.875-19.286,28.257,28.257,0,0,1,9.082-26.368,23.709,23.709,0,0,1,6.886-4.165,17.782,17.782,0,0,1,8.612-1.026,14.936,14.936,0,0,1,8.613,3.885,11.837,11.837,0,0,1,3.4,10.361,17.075,17.075,0,0,1-4.73,8.895,31.253,31.253,0,0,1-7.212,5.489A38.577,38.577,0,0,1,692.7,204.76a33.339,33.339,0,0,1-18.338-4.31A33.952,33.952,0,0,1,660.863,186a30.25,30.25,0,0,1,7.9-36.906,25.142,25.142,0,0,1,8.656-4.514,20.866,20.866,0,0,1,9.746-.313,15.775,15.775,0,0,1,8.846,5.152,15.467,15.467,0,0,1,3.467,9.764,19.044,19.044,0,0,1-2.309,9.3,24.72,24.72,0,0,1-5.458,6.778,36.392,36.392,0,0,1-13.564,7.444,33.733,33.733,0,0,1-14.271,1.138,28.685,28.685,0,0,1-12.42-4.913,27.9,27.9,0,0,1-11.86-19.4,23.982,23.982,0,0,1,4.394-16.637,19.343,19.343,0,0,1,8.13-6.707c2.236-.875,3.511-.845,3.565-.625.094.315-1.012.824-2.826,2.074a21.629,21.629,0,0,0-6.32,7.017,21.31,21.31,0,0,0-2.588,14.211A23.266,23.266,0,0,0,654.5,174.115c5.8,3.807,13.939,4.788,21.755,2.141a30.327,30.327,0,0,0,10.888-6.362c3.131-2.9,5.262-6.631,5.085-10.536-.1-3.915-2.49-6.674-6.555-7.479a13.675,13.675,0,0,0-6.258.306,17.815,17.815,0,0,0-5.907,3.195,22.354,22.354,0,0,0-7.45,12.26,22.048,22.048,0,0,0,1.828,14.694A25.747,25.747,0,0,0,692.365,196.8a31.478,31.478,0,0,0,13.939-3.937,24.094,24.094,0,0,0,5.563-4.049,9.77,9.77,0,0,0,2.822-4.751,4.233,4.233,0,0,0-1.142-3.822,8.208,8.208,0,0,0-4.609-2.1,11.288,11.288,0,0,0-5.429.476,17.255,17.255,0,0,0-5.058,2.861,21.562,21.562,0,0,0-6.6,9.386,22.3,22.3,0,0,0-1.111,10.777,28,28,0,0,0,9.122,16.693,31.764,31.764,0,0,0,13.115,6.761C721.082,227.045,725.943,226.083,726.006,226.788Z",
    transform: "translate(-639.449 -135.429)",
    fill: "#e0e0e0"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_93",
    "data-name": "Group 93",
    transform: "translate(191.492 565.367)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_41",
    "data-name": "Rectangle 41",
    width: 101.557,
    height: 27.748,
    fill: "#f5f5f5"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_97",
    "data-name": "Group 97",
    transform: "translate(384.921)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_94",
    "data-name": "Group 94",
    transform: "translate(43.461)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_42",
    "data-name": "Rectangle 42",
    width: 101.557,
    height: 27.748,
    fill: "#f5f5f5"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_96",
    "data-name": "Group 96",
    transform: "translate(0 28.643)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_95",
    "data-name": "Group 95"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6",
    "data-name": "Path 6",
    d: "M327.706,66.667a3.469,3.469,0,0,1-.031-.5l-.033-1.423q-.028-1.96-.075-5.461c-.042-4.79-.1-11.678-.175-20.36l.315.326-101.551.209c.23-.239-.522.532.511-.535v7.1q0,3.528,0,7-.006,6.946-.008,13.649l-.507-.524,72.374.239c9.04.063,16.294.112,21.36.149l5.778.067,1.511.034a3.192,3.192,0,0,1,.534.035,2.419,2.419,0,0,1-.47.034l-1.449.032-5.667.069-21.245.149-72.726.237-.505,0v-.524q-.006-6.694-.008-13.649,0-3.473,0-7l0-3.54V38.919c1.035-1.069.292-.3.524-.535l101.551.209h.317l0,.326c-.075,8.766-.134,15.716-.175,20.552q-.047,3.457-.075,5.39c-.015.561-.025,1.009-.033,1.365A2.127,2.127,0,0,1,327.706,66.667Z",
    transform: "translate(-225.631 -38.335)",
    fill: "#e0e0e0"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_102",
    "data-name": "Group 102",
    transform: "translate(1269.949 543.438)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_99",
    "data-name": "Group 99",
    transform: "translate(0 27.817)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_98",
    "data-name": "Group 98"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7",
    "data-name": "Path 7",
    d: "M751.7,318.362a3.5,3.5,0,0,1-.031-.5l-.033-1.423q-.028-1.96-.075-5.461c-.042-4.79-.1-11.678-.176-20.36l.315.326-101.551.209c.229-.239-.522.532.511-.535v7.1q0,3.528,0,7-.006,6.946-.008,13.649l-.507-.524c28.921.1,54.224.179,72.374.239,9.04.062,16.294.112,21.362.149,2.463.028,4.394.052,5.776.069l1.511.032a3.516,3.516,0,0,1,.534.034,2.413,2.413,0,0,1-.47.034l-1.448.032-5.667.069-21.245.149-72.726.237-.505,0v-.524q-.006-6.694-.008-13.649,0-3.473,0-7,0-1.762,0-3.54v-3.557c1.035-1.069.292-.3.524-.535l101.551.209h.317l0,.326c-.075,8.766-.134,15.718-.175,20.554q-.047,3.454-.075,5.387l-.033,1.367A2.09,2.09,0,0,1,751.7,318.362Z",
    transform: "translate(-649.621 -290.03)",
    fill: "#e0e0e0"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_101",
    "data-name": "Group 101",
    transform: "translate(54.299)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_100",
    "data-name": "Group 100"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8",
    "data-name": "Path 8",
    d: "M737.18,305.528a2.822,2.822,0,0,1-.04-.528c-.01-.4-.025-.882-.04-1.47q-.034-2.05-.094-5.564c-.048-4.866-.115-11.736-.2-20.185l.372.384-61.014.151c-.463.476.626-.651.513-.533v3.63l0,3.6q0,3.577,0,7.063c-.006,4.641-.013,9.143-.019,13.454l-.493-.509,43.651.241c5.361.058,9.656.108,12.714.14,1.428.028,2.565.047,3.43.065a10.1,10.1,0,0,1,1.225.062,6.963,6.963,0,0,1-1.108.063c-.837.015-1.941.037-3.327.065-3.031.032-7.289.08-12.6.14l-43.983.242-.491,0,0-.511c-.006-4.312-.013-8.813-.019-13.454q0-3.483,0-7.063v-3.6l0-1.815v-1.815c-.113.114.983-1.015.522-.537l61.014.151h.378l0,.384c-.083,8.548-.152,15.5-.2,20.42q-.06,3.457-.094,5.476A16.671,16.671,0,0,1,737.18,305.528Z",
    transform: "translate(-675.634 -277.127)",
    fill: "#e0e0e0"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_107",
    "data-name": "Group 107",
    transform: "translate(756.305 715.428)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_104",
    "data-name": "Group 104",
    transform: "translate(0 27.817)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_103",
    "data-name": "Group 103"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9",
    "data-name": "Path 9",
    d: "M505.625,398.141a3.468,3.468,0,0,1-.031-.5l-.033-1.423q-.028-1.96-.077-5.461c-.04-4.79-.1-11.676-.173-20.36l.313.326-101.549.209c.228-.239-.522.533.511-.535v3.557l0,3.54q0,3.528,0,7,0,6.946-.008,13.649l-.505-.524c28.919.1,54.224.179,72.371.239,9.04.063,16.3.112,21.362.149,2.465.028,4.4.052,5.776.069l1.511.032a3.575,3.575,0,0,1,.536.034,2.417,2.417,0,0,1-.472.035l-1.449.032c-1.355.017-3.248.041-5.667.069l-21.245.149-72.724.237-.505,0,0-.524q0-6.694-.008-13.649,0-3.473,0-7v-7.1c1.035-1.069.29-.3.524-.535l101.549.209h.319l0,.326c-.073,8.766-.132,15.718-.173,20.554q-.05,3.454-.077,5.387l-.031,1.367A2.115,2.115,0,0,1,505.625,398.141Z",
    transform: "translate(-403.55 -369.809)",
    fill: "#e0e0e0"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_106",
    "data-name": "Group 106",
    transform: "translate(54.299)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_105",
    "data-name": "Group 105"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10",
    "data-name": "Path 10",
    d: "M491.107,385.307a3.222,3.222,0,0,1-.038-.528c-.012-.4-.025-.882-.042-1.47l-.092-5.564c-.048-4.866-.117-11.736-.2-20.185l.372.384-61.014.151c-.466.476.624-.651.513-.533v3.63l0,3.6q0,3.577,0,7.062c-.006,4.642-.013,9.143-.019,13.455l-.493-.509,43.649.241c5.36.06,9.658.108,12.716.14,1.428.026,2.563.047,3.428.065a10.078,10.078,0,0,1,1.225.062,6.914,6.914,0,0,1-1.106.063c-.839.015-1.941.037-3.327.065-3.031.032-7.289.08-12.6.14l-43.981.241-.493,0v-.511c-.006-4.312-.013-8.813-.019-13.455q0-3.483,0-7.062l0-3.6v-3.63c-.113.114.981-1.015.522-.537l61.014.151h.376l0,.384c-.084,8.548-.15,15.5-.2,20.42q-.056,3.457-.092,5.476A15.609,15.609,0,0,1,491.107,385.307Z",
    transform: "translate(-429.563 -356.906)",
    fill: "#e0e0e0"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_108",
    "data-name": "Group 108",
    transform: "translate(1052.299 28.749)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_43",
    "data-name": "Rectangle 43",
    width: 101.557,
    height: 27.748,
    fill: "#f5f5f5"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Floor",
    transform: "translate(17.629 942.22)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_109",
    "data-name": "Group 109"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11",
    "data-name": "Path 11",
    d: "M1506.913,451.049c0,.308-333.413.56-744.606.56-411.335,0-744.679-.252-744.679-.56s333.344-.563,744.679-.563C1173.5,450.486,1506.913,450.738,1506.913,451.049Z",
    transform: "translate(-17.629 -450.486)",
    fill: "#263238"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Chart",
    transform: "translate(525.441 132.352)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_184",
    "data-name": "Group 184",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_111",
    "data-name": "Group 111",
    transform: "translate(19.646 9.735)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_44",
    "data-name": "Rectangle 44",
    width: 659.409,
    height: 563.747,
    transform: "translate(0.544 0.561)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_110",
    "data-name": "Group 110"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_12",
    "data-name": "Path 12",
    d: "M930.27,643.644c0-3.928-.18-224.012-.455-563.746l.455.47c-188.824.026-415.647.058-659.351.091h-.058l.545-.561c-.023,204.08-.042,396.671-.061,563.746l-.484-.5c392.534.3,655.189.5,659.409.5-4.219,0-266.876.2-659.409.5l-.484,0v-.5c-.017-167.075-.038-359.666-.058-563.746v-.561h.6c243.7.032,470.527.065,659.351.091h.455v.47C930.452,419.632,930.274,639.718,930.27,643.644Z",
    transform: "translate(-270.318 -79.338)",
    fill: "#263238"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_112",
    "data-name": "Group 112",
    transform: "translate(75.769 161.939)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_13",
    "data-name": "Path 13",
    d: "M825.233,150.5c0,.308-118.212.561-264,.561-145.839,0-264.026-.252-264.026-.561s118.187-.563,264.026-.563C707.02,149.939,825.233,150.191,825.233,150.5Z",
    transform: "translate(-297.205 -149.939)",
    fill: "#e0e0e0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_113",
    "data-name": "Group 113",
    transform: "translate(75.769 222.158)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_14",
    "data-name": "Path 14",
    d: "M825.233,178.433c0,.31-118.212.56-264,.56-145.839,0-264.026-.25-264.026-.56s118.187-.561,264.026-.561C707.02,177.872,825.233,178.122,825.233,178.433Z",
    transform: "translate(-297.205 -177.872)",
    fill: "#e0e0e0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_114",
    "data-name": "Group 114",
    transform: "translate(75.769 282.375)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_15",
    "data-name": "Path 15",
    d: "M825.233,206.365c0,.31-118.212.563-264,.563-145.839,0-264.026-.252-264.026-.563s118.187-.561,264.026-.561C707.02,205.8,825.233,206.054,825.233,206.365Z",
    transform: "translate(-297.205 -205.804)",
    fill: "#e0e0e0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_115",
    "data-name": "Group 115",
    transform: "translate(75.769 342.591)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_16",
    "data-name": "Path 16",
    d: "M825.233,234.3c0,.31-118.212.563-264,.563-145.839,0-264.026-.252-264.026-.563s118.187-.561,264.026-.561C707.02,233.736,825.233,233.988,825.233,234.3Z",
    transform: "translate(-297.205 -233.736)",
    fill: "#e0e0e0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_116",
    "data-name": "Group 116",
    transform: "translate(75.769 402.808)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_17",
    "data-name": "Path 17",
    d: "M825.233,262.231c0,.31-118.212.561-264,.561-145.839,0-264.026-.25-264.026-.561s118.187-.563,264.026-.563C707.02,261.668,825.233,261.92,825.233,262.231Z",
    transform: "translate(-297.205 -261.668)",
    fill: "#e0e0e0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_117",
    "data-name": "Group 117",
    transform: "translate(75.769 463.027)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_18",
    "data-name": "Path 18",
    d: "M825.233,290.161c0,.31-118.212.561-264,.561-145.839,0-264.026-.25-264.026-.561s118.187-.56,264.026-.56C707.02,289.6,825.233,289.851,825.233,290.161Z",
    transform: "translate(-297.205 -289.601)",
    fill: "#e0e0e0"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_45",
    "data-name": "Rectangle 45",
    width: 52.604,
    height: 174.933,
    transform: "translate(399.992 348.306)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_46",
    "data-name": "Rectangle 46",
    width: 52.604,
    height: 232.719,
    transform: "translate(499.33 290.52)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_47",
    "data-name": "Rectangle 47",
    width: 52.604,
    height: 81.881,
    transform: "translate(123.072 441.358)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_48",
    "data-name": "Rectangle 48",
    width: 52.604,
    height: 106.311,
    transform: "translate(210.104 416.927)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_49",
    "data-name": "Rectangle 49",
    width: 52.604,
    height: 137.233,
    transform: "translate(300.301 386.006)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_50",
    "data-name": "Rectangle 50",
    width: 700.001,
    height: 41.55,
    rx: 8.706,
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_118",
    "data-name": "Group 118",
    transform: "translate(74.041 106.903)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_19",
    "data-name": "Path 19",
    d: "M830.93,540.746s-.82.039-2.419.056l-7.1.056c-6.264.026-15.463.06-27.3.106l-100.42.179-331.3.164c-22.427,0-44.486,0-65.471,0h-.538v-.556c.071-117.8.136-221.874.181-296.526.069-37.3.123-67.247.163-87.893.04-10.294.073-18.266.094-23.693.021-2.684.038-4.734.05-6.138.017-1.382.05-2.087.05-2.087s.033.7.05,2.087c.013,1.4.029,3.454.05,6.138.021,5.426.054,13.4.094,23.693.04,20.646.094,50.591.163,87.893.046,74.652.111,178.725.182,296.526l-.539-.556,65.471-.006,331.3.166,100.42.179,27.3.1c3.106.026,5.479.043,7.1.056C830.109,540.708,830.93,540.746,830.93,540.746Z",
    transform: "translate(-296.377 -124.41)",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_119",
    "data-name": "Group 119",
    transform: "translate(74.579 334.552)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_20",
    "data-name": "Path 20",
    d: "M646.668,230.007s-.273.3-.843.854c-.6.576-1.447,1.38-2.542,2.425l-9.852,9.251-36.442,33.931L475.926,388.635l-.386.358-.365-.384c-1.44-1.524-3-3.169-4.561-4.82L411.08,320.815l.691.032c-33.665,29.591-62.4,54.849-82.756,72.738-10.163,8.882-18.231,15.932-23.792,20.793-2.753,2.38-4.882,4.223-6.358,5.5l-1.651,1.4c-.374.31-.578.451-.578.451s.167-.185.522-.519l1.6-1.464c1.451-1.307,3.546-3.191,6.254-5.627,5.517-4.913,13.522-12.04,23.6-21.019l82.5-73.046.361-.319.332.351L471.392,383c1.561,1.651,3.119,3.3,4.561,4.82l-.751-.026c47.523-43.854,90.325-83.349,121.281-111.916,15.478-14.209,27.99-25.7,36.667-33.668,4.317-3.928,7.675-6.989,9.988-9.1,1.127-1.011,2-1.787,2.613-2.343C646.344,230.255,646.668,230.007,646.668,230.007Z",
    transform: "translate(-296.635 -230.007)",
    fill: "#ff725e"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_177",
    "data-name": "Group 177",
    transform: "translate(376.362 86.892)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_120",
    "data-name": "Group 120",
    transform: "translate(0 166.101)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_21",
    "data-name": "Path 21",
    d: "M565.828,218.267l-63.4-26.092c-20.337,1.843-26.549,24.426-22.611,38.751-9.333-2.572-20.045,1.712-25.268,10.1a25.055,25.055,0,0,0,1.605,27.935c-11.134,3.154-17.943,17.316-13.647,28.384S461.2,313.8,471.358,308.144c6.707-3.736,11.222-11.187,18.425-13.746,6.757-2.4,14.1.086,21.216.757,17.676,1.66,35.241-8.783,45.023-24.078S568.413,236.4,565.828,218.267Z",
    transform: "translate(-441.21 -192.175)",
    fill: "#ebebeb"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_173",
    "data-name": "Group 173",
    transform: "translate(34.46)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_166",
    "data-name": "Group 166",
    transform: "translate(0 0.11)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_121",
    "data-name": "Group 121",
    transform: "translate(21.958 175.893)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_22",
    "data-name": "Path 22",
    d: "M495.864,196.768a51.96,51.96,0,0,0-15.7,13.293c-2.824,3.553.434,8.776,4.749,7.645l.115-.03a196.731,196.731,0,0,0-15.72,20.148c-3.07,4.51.96,10.52,6.12,9.106a87.5,87.5,0,0,0,50.03-36.83Z",
    transform: "translate(-468.238 -196.768)",
    fill: "#ff725e"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_123",
    "data-name": "Group 123",
    transform: "translate(40.373 184.482)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_122",
    "data-name": "Group 122"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_23",
    "data-name": "Path 23",
    d: "M484.816,200.752a8.867,8.867,0,0,0-2.8,2.106,3.189,3.189,0,0,0-.495,3.357c.85,1.567,3.215,1.731,3.987,3.341.82,1.71-.708,3.579-2.1,4.836q-2.207,2-4.413,3.986c-1.081.979-2.273,2.32-1.847,3.736.472,1.569,2.5,1.852,4.077,1.669a22.834,22.834,0,0,0,17.442-12.474Z",
    transform: "translate(-477.061 -200.752)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_134",
    "data-name": "Group 134"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_127",
    "data-name": "Group 127",
    transform: "translate(108.677 158.157)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_124",
    "data-name": "Group 124",
    transform: "translate(0.248 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_24",
    "data-name": "Path 24",
    d: "M549.809,188.541c.015.065.044.22.085.453a90.844,90.844,0,0,1-19.461,74.1l-10.673,12.786L509.9,236.347Z",
    transform: "translate(-509.902 -188.541)",
    fill: "#ff725e"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_126",
    "data-name": "Group 126"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_125",
    "data-name": "Group 125"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_25",
    "data-name": "Path 25",
    d: "M549.938,188.541c0,.006-.067.088-.194.248l-.568.692-2.194,2.66c-1.923,2.324-4.707,5.689-8.214,9.93-7.024,8.464-16.939,20.414-28.566,34.426l.048-.209,9,36.026c.3,1.2.6,2.391.872,3.5l-.419-.1q3.191-3.822,6.293-7.537c2.05-2.488,4.15-4.881,6.043-7.349a90.353,90.353,0,0,0,9.621-15.156,87.191,87.191,0,0,0,5.947-15.175c.776-2.44,1.263-4.868,1.814-7.177.405-2.343.885-4.575,1.1-6.743a90.585,90.585,0,0,0,.349-20.556c-.165-2.425-.528-4.279-.676-5.547-.152-1.121-.221-1.645-.261-1.932,0,0,.044.144.115.481s.136.819.24,1.434c.179,1.265.574,3.117.768,5.545a88.677,88.677,0,0,1-.2,20.62c-.207,2.18-.68,4.422-1.077,6.776-.545,2.32-1.023,4.764-1.8,7.216a87.121,87.121,0,0,1-5.932,15.268,90.454,90.454,0,0,1-9.648,15.255c-1.908,2.49-3.993,4.874-6.045,7.366q-3.1,3.716-6.291,7.537l-.3.364-.117-.466c-.276-1.106-.572-2.3-.87-3.5-3.177-12.758-6.21-24.941-8.971-36.035l-.029-.119.077-.093c11.762-14,21.792-25.948,28.9-34.407l8.251-9.794c.943-1.117,1.676-1.983,2.186-2.585l.559-.658C549.877,188.606,549.94,188.535,549.938,188.541Z",
    transform: "translate(-509.783 -188.541)",
    fill: "#263238"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_131",
    "data-name": "Group 131",
    transform: "translate(0 95.514)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_128",
    "data-name": "Group 128",
    transform: "translate(0.488 0.052)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_26",
    "data-name": "Path 26",
    d: "M536.09,159.582c-.065,0-.215-.011-.44-.019a83.585,83.585,0,0,0-67.17,30.371l-10.527,12.609,38.773,4.193Z",
    transform: "translate(-457.953 -159.508)",
    fill: "#ff725e"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_130",
    "data-name": "Group 130"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_129",
    "data-name": "Group 129"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_27",
    "data-name": "Path 27",
    d: "M536.344,159.61s-.052.071-.171.218c-.134.164-.311.379-.539.66-.5.6-1.208,1.464-2.125,2.578-1.885,2.277-4.615,5.577-8.053,9.736-6.959,8.388-16.785,20.228-28.3,34.116l-.077.093-.119-.013c-10.879-1.173-22.83-2.458-35.344-3.805l-3.43-.371-.463-.05.3-.364,6.208-7.433c2.056-2.427,4-4.876,6.081-7.162a86.869,86.869,0,0,1,13.009-11.935,80.86,80.86,0,0,1,13.562-8.2c2.2-1.134,4.442-1.97,6.556-2.856,2.165-.742,4.214-1.544,6.243-2.067a79.514,79.514,0,0,1,19.45-3.195c2.323-.157,4.129-.03,5.35-.03l1.39.035c.328.022.472.043.472.043-.282,0-.785.009-1.864.022-1.219.032-3.023-.065-5.34.123a81.321,81.321,0,0,0-19.367,3.337c-2.016.533-4.054,1.343-6.208,2.089-2.1.892-4.325,1.735-6.517,2.872a81.234,81.234,0,0,0-13.47,8.2,86.827,86.827,0,0,0-12.919,11.9c-2.056,2.266-4.014,4.728-6.066,7.155l-6.2,7.435-.159-.414c1.085.119,2.254.246,3.43.371L497,206.533l-.194.08,28.374-33.782,8.187-9.718c.948-1.121,1.682-1.992,2.194-2.6l.574-.675C536.269,159.692,536.338,159.612,536.344,159.61Z",
    transform: "translate(-457.719 -159.483)",
    fill: "#263238"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_133",
    "data-name": "Group 133",
    transform: "translate(22.823)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_132",
    "data-name": "Group 132"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_28",
    "data-name": "Path 28",
    d: "M664.057,116.9c-5.559-4.948-28.163.791-58.344,17.126a189.8,189.8,0,0,0-48.006,36.96L468.653,277.664,495.87,301.9l15.774,14.045,27.217,24.234,80.811-96.805A195.767,195.767,0,0,0,640.63,212.89a237.684,237.684,0,0,0,15.616-33.87c11.871-32.84,13.368-57.175,7.811-62.122",
    transform: "translate(-468.653 -115.179)",
    fill: "#f5f5f5"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_138",
    "data-name": "Group 138",
    transform: "translate(36.932 145.577)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_135",
    "data-name": "Group 135",
    transform: "translate(0 0.001)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_1",
    "data-name": "Line 1",
    x2: 69.852,
    y2: 61.466,
    fill: "#f5f5f5"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_137",
    "data-name": "Group 137"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_136",
    "data-name": "Group 136"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_29",
    "data-name": "Path 29",
    d: "M545.264,244.173c-.088.106-15.8-13.569-35.083-30.54s-34.857-30.822-34.77-30.928,15.793,13.567,35.085,30.544S545.352,244.068,545.264,244.173Z",
    transform: "translate(-475.412 -182.706)",
    fill: "#263238"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_142",
    "data-name": "Group 142",
    transform: "translate(33.922 148.535)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_139",
    "data-name": "Group 139",
    transform: "translate(0 0.001)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_2",
    "data-name": "Line 2",
    x2: 69.852,
    y2: 61.466,
    fill: "#f5f5f5"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_141",
    "data-name": "Group 141"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_140",
    "data-name": "Group 140"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_30",
    "data-name": "Path 30",
    d: "M543.822,245.545c-.088.106-15.8-13.571-35.083-30.542s-34.857-30.82-34.77-30.925,15.793,13.567,35.085,30.544S543.91,245.44,543.822,245.545Z",
    transform: "translate(-473.97 -184.078)",
    fill: "#263238"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_146",
    "data-name": "Group 146",
    transform: "translate(31.128 151.997)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_143",
    "data-name": "Group 143"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_3",
    "data-name": "Line 3",
    x2: 69.852,
    y2: 61.466,
    fill: "#f5f5f5"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_145",
    "data-name": "Group 145",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_144",
    "data-name": "Group 144"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_31",
    "data-name": "Path 31",
    d: "M542.484,247.149c-.088.106-15.8-13.569-35.083-30.54s-34.857-30.82-34.769-30.925,15.791,13.567,35.085,30.544S542.572,247.044,542.484,247.149Z",
    transform: "translate(-472.632 -185.684)",
    fill: "#263238"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_150",
    "data-name": "Group 150",
    transform: "translate(28.334 155.457)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_147",
    "data-name": "Group 147",
    transform: "translate(0.001 0.001)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_4",
    "data-name": "Line 4",
    x2: 69.852,
    y2: 61.466,
    fill: "#f5f5f5"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_149",
    "data-name": "Group 149"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_148",
    "data-name": "Group 148"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_32",
    "data-name": "Path 32",
    d: "M541.147,248.756c-.088.106-15.8-13.571-35.083-30.542s-34.857-30.82-34.772-30.925,15.793,13.567,35.087,30.544S541.233,248.651,541.147,248.756Z",
    transform: "translate(-471.293 -187.289)",
    fill: "#263238"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_154",
    "data-name": "Group 154",
    transform: "translate(25.541 158.919)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_151",
    "data-name": "Group 151",
    transform: "translate(0.001)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_5",
    "data-name": "Line 5",
    x2: 69.852,
    y2: 61.466,
    fill: "#f5f5f5"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_153",
    "data-name": "Group 153",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_152",
    "data-name": "Group 152"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_33",
    "data-name": "Path 33",
    d: "M539.807,250.36c-.086.106-15.8-13.569-35.081-30.539S469.87,189,469.955,188.9s15.793,13.567,35.087,30.542S539.895,250.255,539.807,250.36Z",
    transform: "translate(-469.955 -188.895)",
    fill: "#263238"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_156",
    "data-name": "Group 156",
    transform: "translate(72.124 127.1)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_155",
    "data-name": "Group 155"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_34",
    "data-name": "Path 34",
    d: "M533.947,174.135a3.421,3.421,0,0,1-.338.565c-.228.382-.633.864-1.125,1.522-1,1.3-2.488,3.141-4.344,5.4-3.716,4.519-8.913,10.7-14.693,17.49s-11.055,12.909-14.889,17.318l-4.563,5.2c-.52.578-.937,1.041-1.259,1.4a3.194,3.194,0,0,1-.463.464,3.089,3.089,0,0,1,.39-.53l1.19-1.46c1.088-1.3,2.6-3.1,4.448-5.305l14.781-17.415c5.761-6.771,10.977-12.9,14.8-17.391,1.856-2.2,3.369-4,4.459-5.29.514-.634.948-1.108,1.19-1.453A3.728,3.728,0,0,1,533.947,174.135Z",
    transform: "translate(-492.271 -174.135)",
    fill: "#263238"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_158",
    "data-name": "Group 158",
    transform: "translate(79.176 96.226)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_157",
    "data-name": "Group 157"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_35",
    "data-name": "Path 35",
    d: "M565.306,221.745c-.088.1-15.751-13.674-34.984-30.774s-34.759-31.053-34.671-31.156,15.749,13.67,34.989,30.777S565.394,221.639,565.306,221.745Z",
    transform: "translate(-495.65 -159.814)",
    fill: "#263238"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_160",
    "data-name": "Group 160",
    transform: "translate(86.801 167.236)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_159",
    "data-name": "Group 159"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_36",
    "data-name": "Path 36",
    d: "M502.56,192.81c0-.026.255-.065.693.065a3.058,3.058,0,0,1,1.822,4.064,2.955,2.955,0,0,1-5.617-.28,3.036,3.036,0,0,1,2.194-3.863c.449-.084.7-.022.7,0,0,.043-.244.05-.647.185a2.974,2.974,0,0,0-1.413,1.048,2.6,2.6,0,0,0-.407,2.471,2.532,2.532,0,0,0,4.791.239,2.609,2.609,0,0,0-.175-2.5,3.01,3.01,0,0,0-1.309-1.186C502.8,192.883,502.556,192.853,502.56,192.81Z",
    transform: "translate(-499.303 -192.752)",
    fill: "#263238"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_162",
    "data-name": "Group 162",
    transform: "translate(104.383 146.946)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_161",
    "data-name": "Group 161"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_37",
    "data-name": "Path 37",
    d: "M510.983,183.4a1.147,1.147,0,0,1,.691.067,3.057,3.057,0,0,1,1.824,4.064,2.956,2.956,0,0,1-5.617-.282,3.032,3.032,0,0,1,2.194-3.861c.449-.086.7-.022.7,0,0,.043-.244.047-.647.185a2.982,2.982,0,0,0-1.413,1.046,2.606,2.606,0,0,0-.407,2.473,2.532,2.532,0,0,0,4.79.239,2.614,2.614,0,0,0-.175-2.5,3.018,3.018,0,0,0-1.309-1.184C511.221,183.47,510.979,183.44,510.983,183.4Z",
    transform: "translate(-507.725 -183.341)",
    fill: "#263238"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_164",
    "data-name": "Group 164",
    transform: "translate(40.291 95.64)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_163",
    "data-name": "Group 163"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_38",
    "data-name": "Path 38",
    d: "M477.021,205.463s26.533-30.348,38.335-45.921c-8.942,4.663-19.1,10.068-26.242,17.318A43.889,43.889,0,0,0,477.021,205.463Z",
    transform: "translate(-477.021 -159.542)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_165",
    "data-name": "Group 165",
    transform: "translate(17.874 239.028)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_39",
    "data-name": "Path 39",
    d: "M471.939,226.1a5.173,5.173,0,0,0-5.6,4.245,5.307,5.307,0,0,0,4.008,5.862,5.161,5.161,0,0,0,5.749-4.029,5.322,5.322,0,0,0-3.795-6.01",
    transform: "translate(-466.282 -226.054)",
    fill: "#ff725e"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_168",
    "data-name": "Group 168",
    transform: "translate(122.894 37.849)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_216",
    "data-name": "Path 216",
    d: "M25.194-.558A24.493,24.493,0,0,1,50.143,24.568,26.428,26.428,0,0,1,24.392,50.5,24.493,24.493,0,0,1-.556,25.37,26.428,26.428,0,0,1,25.194-.558Z",
    transform: "translate(0 32.619) rotate(-38.756)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_167",
    "data-name": "Group 167",
    transform: "translate(9.413 10.236)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_40",
    "data-name": "Path 40",
    d: "M571.487,166.986a51.575,51.575,0,0,0-.225-6.336,26.092,26.092,0,0,0-7.373-15.037,24.4,24.4,0,0,0-9.727-6,23.954,23.954,0,0,0-12.927-.524,22.617,22.617,0,0,0-6.567,2.632,23.207,23.207,0,0,0-5.782,4.672,25.787,25.787,0,0,0-6.523,14.222,26.118,26.118,0,0,0,2.916,15.449,23.709,23.709,0,0,0,4.484,6.006,23.106,23.106,0,0,0,5.734,4.23,23.881,23.881,0,0,0,23.514-.541,25.554,25.554,0,0,0,10.742-12.689,51.22,51.22,0,0,0,1.735-6.082,9.134,9.134,0,0,1-.171,1.645,12.024,12.024,0,0,1-.384,1.97,18.582,18.582,0,0,1-.785,2.626,25.575,25.575,0,0,1-10.75,13.215,24.571,24.571,0,0,1-24.357.776,23.925,23.925,0,0,1-5.993-4.374,24.669,24.669,0,0,1-4.7-6.245,27.165,27.165,0,0,1-3.064-16.126,26.82,26.82,0,0,1,6.83-14.839,24.081,24.081,0,0,1,6.047-4.848,23.453,23.453,0,0,1,6.853-2.708,24.71,24.71,0,0,1,13.424.647,24.99,24.99,0,0,1,9.99,6.321,26.1,26.1,0,0,1,7.254,15.552,18.6,18.6,0,0,1,.134,2.742,12.1,12.1,0,0,1-.1,2.009A9.193,9.193,0,0,1,571.487,166.986Z",
    transform: "translate(-521.104 -137.433)",
    fill: "#263238"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_169",
    "data-name": "Group 169",
    transform: "translate(159.883 0.11)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_41",
    "data-name": "Path 41",
    d: "M592.658,116.9c-5.559-4.948-28.163.791-58.344,17.126l50.533,45c11.871-32.84,13.368-57.175,7.811-62.122",
    transform: "translate(-534.314 -115.179)",
    fill: "#ff725e"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_172",
    "data-name": "Group 172",
    transform: "translate(22.066)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_171",
    "data-name": "Group 171"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_170",
    "data-name": "Group 170"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_42",
    "data-name": "Path 42",
    d: "M664.451,116.956s.307.315.883.983a12.258,12.258,0,0,1,1.53,3.607c.87,3.37,1.083,8.561.484,15.149-1.275,13.166-5.742,32.049-14.96,54.055A235.015,235.015,0,0,1,634.1,225.227a198.726,198.726,0,0,1-12.913,17.561L606.4,260.561c-20.31,24.361-42.818,51.354-66.734,80.04l-.351.42-.407-.362c-11.27-10.031-23.08-20.545-35.1-31.249L468.7,278.144l-.407-.362.351-.42c23.959-28.664,46.5-55.638,66.844-79.975q7.63-9.122,14.837-17.736,3.6-4.3,7.087-8.466c2.407-2.751,4.945-5.234,7.477-7.642a201.691,201.691,0,0,1,30.451-23.574,240.659,240.659,0,0,1,27.768-14.66,152.373,152.373,0,0,1,22.03-8.136c6.2-1.654,11.19-2.287,14.553-1.962a19.333,19.333,0,0,1,2.188.407,11.527,11.527,0,0,1,1.5.582c.726.489,1.075.757,1.075.757s-.395-.213-1.119-.664a12.531,12.531,0,0,0-1.5-.524,20.128,20.128,0,0,0-2.165-.354c-3.329-.257-8.276.435-14.436,2.141a155.353,155.353,0,0,0-21.905,8.281A243.426,243.426,0,0,0,595.708,140.6a202.494,202.494,0,0,0-30.252,23.587c-2.509,2.4-5.043,4.9-7.393,7.6q-3.475,4.175-7.066,8.485l-14.8,17.768c-20.312,24.361-42.823,51.361-66.744,80.052l-.056-.783,35.114,31.257c12.021,10.708,23.827,21.224,35.1,31.257l-.758.058,66.827-79.955,14.829-17.734a198.943,198.943,0,0,0,12.9-17.447,235.455,235.455,0,0,0,18.331-34.288c9.274-21.888,13.841-40.7,15.227-53.8.658-6.552.507-11.71-.294-15.058a12.814,12.814,0,0,0-1.417-3.6C664.712,117.325,664.451,116.956,664.451,116.956Z",
    transform: "translate(-468.29 -115.128)",
    fill: "#263238"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_176",
    "data-name": "Group 176",
    transform: "translate(187.308 58.182)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_174",
    "data-name": "Group 174",
    transform: "translate(5.58)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_43",
    "data-name": "Path 43",
    d: "M535.072,177.573c-.144.011-.438-1.962-.681-5.17s-.426-7.649-.53-12.545c-.079-4.678-.15-8.91-.211-12.536-.046-3.208-.067-5.193.088-5.206s.436,1.96.68,5.17.426,7.647.53,12.547c.077,4.674.15,8.908.211,12.534C535.206,175.572,535.226,177.56,535.072,177.573Z",
    transform: "translate(-533.617 -142.116)",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_175",
    "data-name": "Group 175",
    transform: "translate(0 7.772)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_44",
    "data-name": "Path 44",
    d: "M532.38,168.465c-.3.028-.818-5.049-1.158-11.34s-.374-11.4-.073-11.4.818,5.071,1.158,11.342S532.679,168.437,532.38,168.465Z",
    transform: "translate(-530.943 -145.721)",
    fill: "#263238"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_45",
    "data-name": "Path 45",
    d: "M487.779,251.732a12.648,12.648,0,0,0-13.315,3.411,10.434,10.434,0,0,0-.829,12.1c-4.01,1.7-6.609,6.224-6.521,10.7a13.994,13.994,0,0,0,6.323,11.128,16.7,16.7,0,0,0,12.526,2.147c8.527-1.8,15.365-10.038,15.779-19.014S496.1,254.355,487.779,251.732Z",
    transform: "translate(-36.683 128.869)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46",
    "data-name": "Path 46",
    d: "M444.97,250.055A11.271,11.271,0,1,1,433.7,238.42,11.456,11.456,0,0,1,444.97,250.055Z",
    transform: "translate(-85.259 114.269)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_178",
    "data-name": "Group 178",
    transform: "translate(74.579 137.999)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_47",
    "data-name": "Path 47",
    d: "M322.763,139.4c0,.308-5.849.561-13.063.561s-13.065-.252-13.065-.561,5.849-.563,13.065-.563S322.763,139.086,322.763,139.4Z",
    transform: "translate(-296.635 -138.834)",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_179",
    "data-name": "Group 179",
    transform: "translate(74.579 195.286)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_48",
    "data-name": "Path 48",
    d: "M322.763,165.97c0,.308-5.849.561-13.063.561s-13.065-.252-13.065-.561,5.849-.563,13.065-.563S322.763,165.659,322.763,165.97Z",
    transform: "translate(-296.635 -165.407)",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_180",
    "data-name": "Group 180",
    transform: "translate(74.579 252.572)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_49",
    "data-name": "Path 49",
    d: "M322.763,192.543c0,.308-5.849.561-13.063.561s-13.065-.252-13.065-.561,5.849-.563,13.065-.563S322.763,192.232,322.763,192.543Z",
    transform: "translate(-296.635 -191.98)",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_181",
    "data-name": "Group 181",
    transform: "translate(74.579 309.859)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_50",
    "data-name": "Path 50",
    d: "M322.763,219.116c0,.308-5.849.561-13.063.561s-13.065-.252-13.065-.561,5.849-.563,13.065-.563S322.763,218.805,322.763,219.116Z",
    transform: "translate(-296.635 -218.553)",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_182",
    "data-name": "Group 182",
    transform: "translate(74.579 367.146)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_51",
    "data-name": "Path 51",
    d: "M322.763,245.689c0,.308-5.849.561-13.063.561s-13.065-.252-13.065-.561,5.849-.563,13.065-.563S322.763,245.378,322.763,245.689Z",
    transform: "translate(-296.635 -245.126)",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_183",
    "data-name": "Group 183",
    transform: "translate(74.579 424.433)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_52",
    "data-name": "Path 52",
    d: "M322.763,272.262c0,.308-5.849.56-13.063.56s-13.065-.252-13.065-.56,5.849-.563,13.065-.563S322.763,271.951,322.763,272.262Z",
    transform: "translate(-296.635 -271.699)",
    fill: "#263238"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Character_3",
    "data-name": "Character 3",
    transform: "translate(1001.61 542.325)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_388",
    "data-name": "Group 388"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_369",
    "data-name": "Group 369",
    transform: "translate(157.323)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_363",
    "data-name": "Group 363",
    transform: "translate(0.431)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_186",
    "data-name": "Group 186",
    transform: "translate(0 43.639)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_185",
    "data-name": "Group 185"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_53",
    "data-name": "Path 53",
    d: "M615.584,285.234c-14.8,1.455-25.917,25.182-22.8,37.833,1.513,6.146,4.747,13.086.2,18.066-4.5,4.93-14.689,5.31-18.96,10.363,0,0-5.465,6.506-4.267,14.319s.708,18.366-5.154,21.614l30.9,8.865c2.879-3.482,3.757-8.692,6.636-12.174-3.317,3.671-5.905,16.07,10.3,16.22l9.372-9.88c27.91,5.208,57.33,12.081,78.352-1.871",
    transform: "translate(-564.6 -285.234)",
    fill: "#263238"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_188",
    "data-name": "Group 188",
    transform: "translate(38.164)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_187",
    "data-name": "Group 187"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_54",
    "data-name": "Path 54",
    d: "M740.048,366.222c-2.394-5.739-6.022-10.924-7.821-16.891-3.868-12.827,1-28.136-6.191-39.331-5.116-7.968-14.8-11.191-23.859-13.159s-17.647-2.887-24.809-8.945c-5.252-4.443-8.592-10.93-13.831-15.393-7.464-6.355-17.78-7.774-27.451-7.474-9.932.308-20.055,2.255-28.541,7.6s-15.111,14.492-15.8,24.73c-.336,4.991.706,10.089-.376,14.968-1.188,5.362-4.79,9.787-6.8,14.884-4.246,10.768-.223,24.346,9.132,30.815l75.824,84.039c14.735,4.21,29.031-15.815,39.078-27.72S746.1,380.724,740.048,366.222Z",
    transform: "translate(-582.883 -264.992)",
    fill: "#263238"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_193",
    "data-name": "Group 193",
    transform: "translate(48.931 36.659)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_192",
    "data-name": "Group 192"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_191",
    "data-name": "Group 191"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_190",
    "data-name": "Group 190"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_189",
    "data-name": "Group 189"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_55",
    "data-name": "Path 55",
    d: "M588.867,326.705c.973-20.8,13.944-46.5,34.024-44.611l62.836,15.4c6.1.573,9.681,5.31,9.65,11.635l-3.413,156.582c.148.03.286.058.434.091,0,0-13.543,44.22-55.136,31.505-8.247-2.52-11.677.658-13.457-8.848h0c-1.806-.584,0-.052-.035-1.132-.683-11.708-1.547-35.856-1.547-35.856h0c-.321-12.583-.392-17.747-.4-17.628,0,0-25.769-4.021-31.586-38.581C587.345,378.074,587.786,349.816,588.867,326.705Z",
    transform: "translate(-588.041 -281.996)",
    fill: "#ffbf9d"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_360",
    "data-name": "Group 360",
    transform: "translate(54.757 74.463)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_359",
    "data-name": "Group 359"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_326",
    "data-name": "Group 326",
    transform: "translate(0 16.916)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_325",
    "data-name": "Group 325"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_324",
    "data-name": "Group 324"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_240",
    "data-name": "Group 240",
    transform: "translate(0 0.002)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_208",
    "data-name": "Group 208",
    transform: "translate(46.612 12.185)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_207",
    "data-name": "Group 207"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_206",
    "data-name": "Group 206"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_205",
    "data-name": "Group 205"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_204",
    "data-name": "Group 204"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_203",
    "data-name": "Group 203"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_202",
    "data-name": "Group 202"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_201",
    "data-name": "Group 201"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_200",
    "data-name": "Group 200"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_199",
    "data-name": "Group 199"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_198",
    "data-name": "Group 198"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_197",
    "data-name": "Group 197"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_196",
    "data-name": "Group 196"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_195",
    "data-name": "Group 195"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_194",
    "data-name": "Group 194"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_56",
    "data-name": "Path 56",
    d: "M613.163,317.109a4.377,4.377,0,0,0,4.21,4.419,4.17,4.17,0,0,0,4.379-4.072,4.381,4.381,0,0,0-4.206-4.422A4.173,4.173,0,0,0,613.163,317.109Z",
    transform: "translate(-613.162 -313.031)",
    fill: "#263238"
  })))))))))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_223",
    "data-name": "Group 223",
    transform: "translate(2.111 12.888)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_222",
    "data-name": "Group 222"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_221",
    "data-name": "Group 221"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_220",
    "data-name": "Group 220"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_219",
    "data-name": "Group 219"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_218",
    "data-name": "Group 218"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_217",
    "data-name": "Group 217"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_216",
    "data-name": "Group 216"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_215",
    "data-name": "Group 215"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_214",
    "data-name": "Group 214"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_213",
    "data-name": "Group 213"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_212",
    "data-name": "Group 212"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_211",
    "data-name": "Group 211"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_210",
    "data-name": "Group 210"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_209",
    "data-name": "Group 209"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_57",
    "data-name": "Path 57",
    d: "M591.844,317.438a4.378,4.378,0,0,0,4.21,4.419,4.168,4.168,0,0,0,4.377-4.072,4.383,4.383,0,0,0-4.206-4.424A4.171,4.171,0,0,0,591.844,317.438Z",
    transform: "translate(-591.844 -313.357)",
    fill: "#263238"
  })))))))))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_239",
    "data-name": "Group 239"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_238",
    "data-name": "Group 238"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_237",
    "data-name": "Group 237"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_236",
    "data-name": "Group 236"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_235",
    "data-name": "Group 235"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_234",
    "data-name": "Group 234"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_233",
    "data-name": "Group 233"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_232",
    "data-name": "Group 232"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_231",
    "data-name": "Group 231"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_230",
    "data-name": "Group 230"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_229",
    "data-name": "Group 229"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_228",
    "data-name": "Group 228"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_227",
    "data-name": "Group 227"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_226",
    "data-name": "Group 226"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_225",
    "data-name": "Group 225"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_224",
    "data-name": "Group 224"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_58",
    "data-name": "Path 58",
    d: "M590.892,312.835c.534.765,4.281-2.208,9.32-1.929,5.041.192,8.548,3.5,9.141,2.787.29-.315-.221-1.671-1.743-3.165a11.378,11.378,0,0,0-7.26-3.139,11.188,11.188,0,0,0-7.477,2.453C591.234,311.193,590.627,312.493,590.892,312.835Z",
    transform: "translate(-590.832 -307.379)",
    fill: "#263238"
  })))))))))))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_257",
    "data-name": "Group 257",
    transform: "translate(45.963)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_256",
    "data-name": "Group 256"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_255",
    "data-name": "Group 255"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_254",
    "data-name": "Group 254"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_253",
    "data-name": "Group 253"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_252",
    "data-name": "Group 252"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_251",
    "data-name": "Group 251"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_250",
    "data-name": "Group 250"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_249",
    "data-name": "Group 249"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_248",
    "data-name": "Group 248"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_247",
    "data-name": "Group 247"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_246",
    "data-name": "Group 246"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_245",
    "data-name": "Group 245"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_244",
    "data-name": "Group 244"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_243",
    "data-name": "Group 243"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_242",
    "data-name": "Group 242"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_241",
    "data-name": "Group 241"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_59",
    "data-name": "Path 59",
    d: "M612.942,313.727c.653.688,4.3-2.613,9.675-2.882,5.367-.358,9.443,2.492,9.994,1.733.271-.339-.409-1.6-2.194-2.9a12.729,12.729,0,0,0-8.041-2.281,12.476,12.476,0,0,0-7.659,3.2C613.132,312.086,612.624,313.42,612.942,313.727Z",
    transform: "translate(-612.852 -307.378)",
    fill: "#263238"
  })))))))))))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_274",
    "data-name": "Group 274",
    transform: "translate(18.512 0.641)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_273",
    "data-name": "Group 273"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_272",
    "data-name": "Group 272"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_271",
    "data-name": "Group 271"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_270",
    "data-name": "Group 270"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_269",
    "data-name": "Group 269"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_268",
    "data-name": "Group 268"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_267",
    "data-name": "Group 267"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_266",
    "data-name": "Group 266"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_265",
    "data-name": "Group 265"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_264",
    "data-name": "Group 264"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_263",
    "data-name": "Group 263"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_262",
    "data-name": "Group 262"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_261",
    "data-name": "Group 261"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_260",
    "data-name": "Group 260"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_259",
    "data-name": "Group 259"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_258",
    "data-name": "Group 258"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_60",
    "data-name": "Path 60",
    d: "M611.545,347.54c.017-.272-2.868-.742-7.54-1.287-1.184-.108-2.3-.334-2.517-1.162-.29-.88.186-2.2.739-3.633q1.6-4.453,3.363-9.348c4.667-13.306,8.028-24.242,7.506-24.432s-4.726,10.445-9.391,23.751q-1.685,4.922-3.217,9.4c-.428,1.395-1.175,2.979-.545,4.8a2.991,2.991,0,0,0,1.968,1.755,7.768,7.768,0,0,0,2.012.259C608.619,347.835,611.53,347.813,611.545,347.54Z",
    transform: "translate(-599.701 -307.676)",
    fill: "#263238"
  })))))))))))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_290",
    "data-name": "Group 290",
    transform: "translate(27.958 84.072)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_289",
    "data-name": "Group 289"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_288",
    "data-name": "Group 288"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_287",
    "data-name": "Group 287"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_286",
    "data-name": "Group 286"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_285",
    "data-name": "Group 285"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_284",
    "data-name": "Group 284"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_283",
    "data-name": "Group 283"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_282",
    "data-name": "Group 282"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_281",
    "data-name": "Group 281"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_280",
    "data-name": "Group 280"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_279",
    "data-name": "Group 279"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_278",
    "data-name": "Group 278"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_277",
    "data-name": "Group 277"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_276",
    "data-name": "Group 276"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_275",
    "data-name": "Group 275"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_61",
    "data-name": "Path 61",
    d: "M604.226,359.43a83.19,83.19,0,0,0,44.745-13.053s-10.923,25.534-44.538,22.8Z",
    transform: "translate(-604.226 -346.376)",
    fill: "#ff9a6c"
  }))))))))))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_306",
    "data-name": "Group 306",
    transform: "translate(32.026 48.649)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_305",
    "data-name": "Group 305"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_304",
    "data-name": "Group 304"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_303",
    "data-name": "Group 303"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_302",
    "data-name": "Group 302"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_301",
    "data-name": "Group 301"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_300",
    "data-name": "Group 300"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_299",
    "data-name": "Group 299"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_298",
    "data-name": "Group 298"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_297",
    "data-name": "Group 297"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_296",
    "data-name": "Group 296"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_295",
    "data-name": "Group 295"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_294",
    "data-name": "Group 294"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_293",
    "data-name": "Group 293"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_292",
    "data-name": "Group 292"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_291",
    "data-name": "Group 291"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_62",
    "data-name": "Path 62",
    d: "M606.624,333.293a8.229,8.229,0,0,1,7.433-3.311,7.532,7.532,0,0,1,5.3,2.833,5.12,5.12,0,0,1,.449,5.694c-1.223,1.832-3.828,2.292-6.047,1.675a17.37,17.37,0,0,1-5.966-3.557,5.145,5.145,0,0,1-1.342-1.393,1.638,1.638,0,0,1-.019-1.781",
    transform: "translate(-606.175 -329.945)",
    fill: "#ff725e"
  }))))))))))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_323",
    "data-name": "Group 323",
    transform: "translate(29.45 43.607)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_322",
    "data-name": "Group 322"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_321",
    "data-name": "Group 321"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_320",
    "data-name": "Group 320"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_319",
    "data-name": "Group 319"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_318",
    "data-name": "Group 318"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_317",
    "data-name": "Group 317"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_316",
    "data-name": "Group 316"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_315",
    "data-name": "Group 315"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_314",
    "data-name": "Group 314"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_313",
    "data-name": "Group 313"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_312",
    "data-name": "Group 312"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_311",
    "data-name": "Group 311"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_310",
    "data-name": "Group 310"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_309",
    "data-name": "Group 309"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_308",
    "data-name": "Group 308"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_307",
    "data-name": "Group 307"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_63",
    "data-name": "Path 63",
    d: "M619.515,327.606c-.754-.032-.691,5.155-4.939,8.9s-9.6,3.257-9.633,3.984c-.067.328,1.207.989,3.467,1.02a12.264,12.264,0,0,0,8.047-3.033,11.377,11.377,0,0,0,3.818-7.459C620.436,328.848,619.858,327.572,619.515,327.606Z",
    transform: "translate(-604.941 -327.606)",
    fill: "#263238"
  }))))))))))))))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_342",
    "data-name": "Group 342",
    transform: "translate(45.033 3.325)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_341",
    "data-name": "Group 341"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_340",
    "data-name": "Group 340"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_339",
    "data-name": "Group 339"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_338",
    "data-name": "Group 338"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_337",
    "data-name": "Group 337"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_336",
    "data-name": "Group 336"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_335",
    "data-name": "Group 335"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_334",
    "data-name": "Group 334"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_333",
    "data-name": "Group 333"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_332",
    "data-name": "Group 332"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_331",
    "data-name": "Group 331"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_330",
    "data-name": "Group 330"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_329",
    "data-name": "Group 329"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_328",
    "data-name": "Group 328"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_327",
    "data-name": "Group 327"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_64",
    "data-name": "Path 64",
    d: "M612.433,304.795c.474,1.294,5.087.608,10.527,1.2,5.452.481,9.855,2.057,10.56.88.313-.561-.467-1.772-2.256-3.005a17.895,17.895,0,0,0-16.065-1.585C613.216,303.146,612.228,304.18,612.433,304.795Z",
    transform: "translate(-612.406 -301.074)",
    fill: "#263238"
  }))))))))))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_358",
    "data-name": "Group 358",
    transform: "translate(0.124)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_357",
    "data-name": "Group 357"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_356",
    "data-name": "Group 356"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_355",
    "data-name": "Group 355"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_354",
    "data-name": "Group 354"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_353",
    "data-name": "Group 353"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_352",
    "data-name": "Group 352"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_351",
    "data-name": "Group 351"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_350",
    "data-name": "Group 350"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_349",
    "data-name": "Group 349"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_348",
    "data-name": "Group 348"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_347",
    "data-name": "Group 347"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_346",
    "data-name": "Group 346"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_345",
    "data-name": "Group 345"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_344",
    "data-name": "Group 344"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_343",
    "data-name": "Group 343"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_65",
    "data-name": "Path 65",
    d: "M591.034,304.624c.946,1.071,4.575-.11,8.957-.229,4.375-.259,8.1.606,8.94-.541.367-.558-.234-1.636-1.868-2.641a13.4,13.4,0,0,0-7.308-1.669,13.27,13.27,0,0,0-7.114,2.29C591.109,302.975,590.617,304.1,591.034,304.624Z",
    transform: "translate(-590.892 -299.532)",
    fill: "#263238"
  }))))))))))))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_362",
    "data-name": "Group 362",
    transform: "translate(72.703 31.111)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_361",
    "data-name": "Group 361"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_66",
    "data-name": "Path 66",
    d: "M741.345,341.44c-3.588-5.782,2.023-12.961-3.214-18.148-4.776-4.732-16.426-4.029-20.941-8.878-3.526-3.788-3.738-4.84-4.114-8.613-.472-4.726-3.96-24.471-32.371-26.379L678.089,297.8c-1.816-.718-3.69-1.315-5.536-1.858A299.281,299.281,0,0,0,600.3,284.052c-2.551,5.4.845,12.1,5.713,15.4s10.825,4.217,16.438,5.8,11.468,4.288,14.192,9.6c2.9,5.648,1.509,12.795,4.129,18.585,4.509,9.964,18.726,11.969,23.18,21.959,3.367,7.556-.276,16.285-.643,24.594a30.776,30.776,0,0,0,10.95,24.775c5.648,4.607,15.3,13.013,15.785,11.141l71.829-54.346C765.421,350.32,746.257,349.352,741.345,341.44Z",
    transform: "translate(-599.43 -279.423)",
    fill: "#263238"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_364",
    "data-name": "Group 364",
    transform: "translate(70.861 35.119)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_67",
    "data-name": "Path 67",
    d: "M688.243,410.015a23.258,23.258,0,0,1-6.631-1.8A32.708,32.708,0,0,1,667.043,396.3a34.21,34.21,0,0,1-5.108-12.312,35.19,35.19,0,0,1,.288-15.358c.595-2.637,1.357-5.278,1.785-8.013a18.7,18.7,0,0,0-.34-8.283,10.233,10.233,0,0,0-5.216-6.26c-2.509-1.371-5.421-2.029-8.31-2.953-2.874-.895-5.853-2.113-7.968-4.488a15.765,15.765,0,0,1-3.469-8.384c-.856-5.842-.3-11.689-2.563-16.421l-.422-.862-.53-.783a9.532,9.532,0,0,0-1.167-1.457,12.778,12.778,0,0,0-2.912-2.188,26.1,26.1,0,0,0-6.669-2.3c-4.482-.983-8.875-1.733-12.434-3.725a26.58,26.58,0,0,1-8.237-7.054,27.3,27.3,0,0,1-4-7.246,24.951,24.951,0,0,1-1.29-5.094,11.539,11.539,0,0,1-.123-1.83,35.094,35.094,0,0,0,1.806,6.765,27.691,27.691,0,0,0,4.083,7.009,26.233,26.233,0,0,0,8.118,6.746c3.455,1.878,7.715,2.565,12.276,3.521a26.769,26.769,0,0,1,6.922,2.343A13.623,13.623,0,0,1,634.712,310a10.484,10.484,0,0,1,1.282,1.578l.582.854.461.929c2.444,5.112,1.851,11.059,2.72,16.712a14.687,14.687,0,0,0,3.21,7.8c1.9,2.132,4.659,3.294,7.494,4.174,2.839.914,5.8,1.572,8.5,3.038a12.483,12.483,0,0,1,3.586,2.861,11.523,11.523,0,0,1,2.14,4.057,19.773,19.773,0,0,1,.351,8.787c-.455,2.829-1.238,5.482-1.837,8.08a34.444,34.444,0,0,0,4.479,26.982,33.059,33.059,0,0,0,14.1,11.956,35.394,35.394,0,0,0,4.764,1.718A12.175,12.175,0,0,1,688.243,410.015Z",
    transform: "translate(-598.341 -281.282)",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_365",
    "data-name": "Group 365",
    transform: "translate(0 44.072)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_68",
    "data-name": "Path 68",
    d: "M619.257,286.466a45.143,45.143,0,0,0-5.154-.558,23.6,23.6,0,0,0-13.332,3.794A24.674,24.674,0,0,0,589.99,307.14a46.412,46.412,0,0,0,.428,12.65c.315,2.195.71,4.413,1.081,6.7a24.579,24.579,0,0,1,.246,7.14,8.537,8.537,0,0,1-3.6,6.211,13.7,13.7,0,0,1-6.561,1.742,23.079,23.079,0,0,0-6.129,1,15.062,15.062,0,0,0-5.045,3.066,15.47,15.47,0,0,0-5.014,9.727,32.8,32.8,0,0,0,.779,9.917,73.129,73.129,0,0,1,1.363,8.276,22.248,22.248,0,0,1-.29,6.36,12.7,12.7,0,0,1-1.365,3.766,7.083,7.083,0,0,1-.557.873c-.138.19-.215.28-.23.267a17.4,17.4,0,0,0,1.737-4.991,22.827,22.827,0,0,0,.1-6.217,78.113,78.113,0,0,0-1.509-8.173,33.08,33.08,0,0,1-.923-10.186,16.386,16.386,0,0,1,5.244-10.391,16.015,16.015,0,0,1,5.371-3.307,23.788,23.788,0,0,1,6.381-1.078,12.838,12.838,0,0,0,6.066-1.587,7.419,7.419,0,0,0,3.106-5.439c.6-4.536-.783-9.085-1.3-13.513A46.854,46.854,0,0,1,589,307a25.324,25.324,0,0,1,11.368-17.969,23.341,23.341,0,0,1,13.754-3.555,21.038,21.038,0,0,1,3.847.571A5.458,5.458,0,0,1,619.257,286.466Z",
    transform: "translate(-564.393 -285.435)",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_368",
    "data-name": "Group 368",
    transform: "translate(65.889 21.307)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_367",
    "data-name": "Group 367"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_366",
    "data-name": "Group 366"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_69",
    "data-name": "Path 69",
    d: "M731.956,391.285a3.689,3.689,0,0,1,.146-.55,10.88,10.88,0,0,0,.409-1.6,14.47,14.47,0,0,0-.2-6.293,15.6,15.6,0,0,0-5.15-8.278,12.554,12.554,0,0,0-5.415-2.585c-2.1-.446-4.417-.47-6.79-1.119a8.922,8.922,0,0,1-3.384-1.71,9.213,9.213,0,0,1-2.409-3.219,20.883,20.883,0,0,1-1.57-8.354,47.9,47.9,0,0,0-.528-8.964,11.791,11.791,0,0,0-1.722-4.221,10.456,10.456,0,0,0-3.413-3.081c-2.737-1.552-5.995-2.089-9.262-2.665s-6.738-1.121-9.846-2.943a11.682,11.682,0,0,1-3.926-3.734,17.333,17.333,0,0,1-2.138-5.129c-.939-3.615-1.209-7.382-2.14-11.008a21.22,21.22,0,0,0-14.107-14.929c-3.269-1.054-6.686-.875-10.026-.962a22.47,22.47,0,0,1-4.968-.578,10.153,10.153,0,0,1-4.419-2.257c-2.524-2.281-3.565-5.5-4.795-8.287a21.42,21.42,0,0,0-18.893-13.439,19.461,19.461,0,0,0-12.107,3.68,23.3,23.3,0,0,0-6.588,7.3,21.942,21.942,0,0,0-2.313,5.879c-.2.7-.24,1.261-.328,1.626a3.649,3.649,0,0,1-.119.554,15.874,15.874,0,0,1,.313-2.21,21.2,21.2,0,0,1,2.217-5.985,23.412,23.412,0,0,1,6.6-7.481,19.788,19.788,0,0,1,12.338-3.853,21.915,21.915,0,0,1,19.419,13.683c1.242,2.813,2.3,5.941,4.659,8.05,2.355,2.138,5.73,2.593,9,2.656,3.292.082,6.8-.114,10.2.972a21.877,21.877,0,0,1,14.57,15.4c.95,3.715,1.217,7.481,2.135,11.006a16.563,16.563,0,0,0,2.044,4.926,11.025,11.025,0,0,0,3.7,3.529c6.014,3.417,13.278,2.384,19.081,5.635a11.075,11.075,0,0,1,3.6,3.281,12.393,12.393,0,0,1,1.808,4.454,48.183,48.183,0,0,1,.505,9.083,20.439,20.439,0,0,0,1.48,8.132,8.727,8.727,0,0,0,2.254,3.05,8.443,8.443,0,0,0,3.2,1.634c2.284.645,4.6.69,6.748,1.16a12.917,12.917,0,0,1,5.565,2.716,15.828,15.828,0,0,1,5.17,8.518,14.236,14.236,0,0,1,.075,6.388,8.926,8.926,0,0,1-.476,1.593A3.564,3.564,0,0,1,731.956,391.285Z",
    transform: "translate(-595.959 -274.875)",
    fill: "#455a64"
  }))))), /*#__PURE__*/React.createElement("path", {
    id: "Path_70",
    "data-name": "Path 70",
    d: "M637.554,568.805h163.26l-14.332-36.912s-51.166-144.24-61.757-155.923c-13.881-15.311-36.8-27.588-36.8-27.588l-70.639,36.891s-20.492,60.079-23.22,83.739c-.639,5.543-1.006,11.253-1.109,16.992-.522,29.548,16.854,56.312,43.34,67.493h0Z",
    transform: "translate(-376.025 -168.607)",
    fill: "#ff725e"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_371",
    "data-name": "Group 371",
    transform: "translate(184.16 153.072)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_71",
    "data-name": "Path 71",
    d: "M639.11,351.508l-7.807,8.861s1.215-17.113-.772-19.165-4.636,0-4.636,0a6.16,6.16,0,0,0-4.306-4.1c-3.313-.683-6.955,1.712-6.955,1.712s-6.625-4.353-10.268-1.835a16.673,16.673,0,0,0-4.968,4.913s-4.306,1.026-6.625,3.419-2.649,3.311-2.649,3.311-3.974,1.479-3.974,4.215-4.306,30.1-5.3,40.366-3.3,26.135-3.3,26.135l39.979-.726s.563-21.343,1.3-23.915a33.97,33.97,0,0,0,12.161-9.912c5.63-7.183,9.875-18.131,12.906-23.4,1.82-3.158,7.007-12.148,7.022-12.926.044-2.466-2.659-3.225-4.956-2.628C643.4,346.5,641.041,349.652,639.11,351.508Z",
    transform: "translate(-576.927 -335.769)",
    fill: "#ffbf9d"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_370",
    "data-name": "Group 370"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_72",
    "data-name": "Path 72",
    d: "M639.433,351.734a11.774,11.774,0,0,1,.883-1.007c.595-.647,1.434-1.656,2.682-2.831a10.219,10.219,0,0,1,2.33-1.679,5.8,5.8,0,0,1,3.4-.487,3.633,3.633,0,0,1,1.824.8,2.678,2.678,0,0,1,.921,2.007,6.988,6.988,0,0,1-.85,2.162q-.529,1.012-1.092,2.078c-1.52,2.826-3.277,5.913-5.177,9.27-1.839,3.363-3.517,7.213-5.525,11.212a71.689,71.689,0,0,1-7.352,12.224,35.155,35.155,0,0,1-12.157,9.882l.276-.313c-.547,3.512-.62,7.517-.825,11.473-.134,4-.271,8.112-.411,12.316l-.017.507-.486.009-39.98.759-.63.013.083-.655c.3-2.376.622-4.926.946-7.494q1.115-8.8,2.194-17.337c.622-5.717,1.369-11.305,2.135-16.757s1.532-10.775,2.267-15.955c.357-2.589.724-5.148,1-7.651.1-.655.05-1.134.188-1.949a4.122,4.122,0,0,1,1.008-1.852,8.8,8.8,0,0,1,3.21-2.111l-.29.3a16.518,16.518,0,0,1,4.217-4.676,17.886,17.886,0,0,1,5.408-2.341l-.3.226a16.172,16.172,0,0,1,3.284-3.656,23.375,23.375,0,0,1,1.883-1.423,5.282,5.282,0,0,1,2.313-.789c3.206-.172,5.943,1.218,8.377,2.669h-.438a10.836,10.836,0,0,1,6.913-1.794,6.294,6.294,0,0,1,4.909,4.439l-.557-.19a4.343,4.343,0,0,1,3.732-.819,2.833,2.833,0,0,1,1.549,1.175,2.718,2.718,0,0,1,.378.9,4.955,4.955,0,0,1,.207.882,40.285,40.285,0,0,1,.413,6.582c-.015,4.122-.219,7.714-.44,10.76l-.374-.166c2.52-2.792,4.488-4.971,5.874-6.506l1.54-1.666a3.833,3.833,0,0,1,.551-.537,4.091,4.091,0,0,1-.47.619L637.5,354.1l-5.715,6.646-.409.474.036-.64c.169-3.035.321-6.629.288-10.723a39.724,39.724,0,0,0-.47-6.452,4.4,4.4,0,0,0-.493-1.516,2.17,2.17,0,0,0-1.2-.895,3.682,3.682,0,0,0-3.1.735l-.4.285-.161-.474a5.542,5.542,0,0,0-4.333-3.865,10.132,10.132,0,0,0-6.364,1.72l-.217.131-.223-.131c-2.3-1.371-5.056-2.676-7.851-2.486a4.434,4.434,0,0,0-1.914.655,22.23,22.23,0,0,0-1.8,1.375,15.442,15.442,0,0,0-3.056,3.413l-.109.177-.188.052a17.135,17.135,0,0,0-5.093,2.231,11.17,11.17,0,0,0-2.1,1.938,12.68,12.68,0,0,0-1.726,2.272l-.117.224-.173.071a7.965,7.965,0,0,0-2.82,1.863,3.114,3.114,0,0,0-.762,1.386c-.088.423-.075,1.227-.163,1.826-.271,2.548-.63,5.1-.981,7.694q-1.086,7.774-2.229,15.962c-.758,5.452-1.5,11.029-2.108,16.716q-1.08,8.544-2.192,17.374c-.326,2.572-.649,5.129-.95,7.509l-.547-.645c14.061-.244,27.574-.481,39.982-.7l-.5.515c.154-4.21.3-8.33.449-12.334a112.158,112.158,0,0,1,.908-11.7l.033-.2.242-.114a34.433,34.433,0,0,0,11.842-9.548,71.439,71.439,0,0,0,7.335-12.025c2.031-3.969,3.732-7.791,5.634-11.191,1.937-3.346,3.72-6.4,5.273-9.2l1.113-2.05a7.609,7.609,0,0,0,.818-1.9,2.513,2.513,0,0,0-2.325-2.391,5.446,5.446,0,0,0-3.181.39,10.1,10.1,0,0,0-2.288,1.569C640.731,350.443,639.5,351.814,639.433,351.734Z",
    transform: "translate(-577.25 -335.995)",
    fill: "#ff9a6c"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_372",
    "data-name": "Group 372",
    transform: "translate(233.524 280.209)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_73",
    "data-name": "Path 73",
    d: "M615.248,464.072,600.9,477.361c20.254.709,37.4-9.654,53.748-22.026s46.542-40.206,51.988-60.365C679.351,410.735,638.873,442.923,615.248,464.072Z",
    transform: "translate(-600.899 -394.969)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_381",
    "data-name": "Group 381",
    transform: "translate(0 299.76)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_380",
    "data-name": "Group 380"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_74",
    "data-name": "Path 74",
    d: "M529.053,408.158c-.374.06-27.846-3.2-34.937-3.885a4.651,4.651,0,0,0-4.905,3.152c-.466,1.47-.192,3.066,2.34,4.008,7.076,2.632,31.647,5.795,31.647,5.795s-10.971-.819-11.4,3.635,5.029,7.466,5.029,7.466-3.655,1.567-2.843,4.844,5.972,5.631,5.972,5.631l2.77,1.19s-4.565-.028-4.638,2.583,2.482,4.954,4.928,5.532,13.66,2.982,13.66,2.982l8.228-20.334-6.258-19.446Z",
    transform: "translate(-489.024 -403.792)",
    fill: "#ffbf9d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_75",
    "data-name": "Path 75",
    d: "M600.375,420.105s-36.1,3.723-38.879,2.35-31.258-16.764-35.644-17.98-25.211.494-25.211.494-4.482,4.952,5.481,8.1c10.349,3.262,16.206,2.022,14.891,2.561l-2.469,34.414s17.672,7.235,25.75,6.646l11.263-3.348,51.293,9.352Z",
    transform: "translate(-477.486 -404.038)",
    fill: "#ffbf9d"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_374",
    "data-name": "Group 374",
    transform: "translate(29.794 13.094)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_76",
    "data-name": "Path 76",
    d: "M506.711,410.118a42.58,42.58,0,0,0,4.248,1.923,8.984,8.984,0,0,1,3.739,2.753,4.391,4.391,0,0,1,.516,4.5c-.9,1.664-2.968,2.188-4.811,2.333a24.055,24.055,0,0,1-7.1-.5",
    transform: "translate(-503.297 -410.104)",
    fill: "#ffbf9d"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_373",
    "data-name": "Group 373"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_77",
    "data-name": "Path 77",
    d: "M503.3,421.133c.033-.17,1.5.1,3.878.14a24.568,24.568,0,0,0,4.12-.261c1.461-.246,3.166-.912,3.644-2.466a4.377,4.377,0,0,0-1.363-4.253,12.422,12.422,0,0,0-3.455-2.175c-2.211-.968-3.511-1.845-3.413-1.992a29.447,29.447,0,0,1,3.7,1.257,11.62,11.62,0,0,1,3.841,2.147,5.323,5.323,0,0,1,1.72,5.362A4.114,4.114,0,0,1,514,421.239a7.4,7.4,0,0,1-2.551.8,19.6,19.6,0,0,1-4.317.03C504.695,421.814,503.265,421.265,503.3,421.133Z",
    transform: "translate(-503.298 -410.112)",
    fill: "#ff9a6c"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_376",
    "data-name": "Group 376",
    transform: "translate(34.518 25.741)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_78",
    "data-name": "Path 78",
    d: "M505.561,426.392a54.282,54.282,0,0,0,17.079-.772c1.733-.358,3.718-1.043,4.273-2.777a3.723,3.723,0,0,0-1.394-3.835,8.943,8.943,0,0,0-3.908-1.55,93.866,93.866,0,0,0-13.023-1.429",
    transform: "translate(-505.561 -415.919)",
    fill: "#ffbf9d"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_375",
    "data-name": "Group 375"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_79",
    "data-name": "Path 79",
    d: "M508.588,416.088c.008-.14,2.474-.179,6.463.082a55.654,55.654,0,0,1,6.984.91,8.444,8.444,0,0,1,4.012,1.727,4.747,4.747,0,0,1,1.361,2.1,3.543,3.543,0,0,1-.194,2.684c-.935,1.712-2.676,2.184-4.06,2.537-1.436.3-2.8.522-4.125.688a49.633,49.633,0,0,1-7.035.377,40.443,40.443,0,0,1-4.728-.36,4.9,4.9,0,0,1-1.705-.382c.019-.177,2.474.056,6.429-.052a60.9,60.9,0,0,0,6.909-.61c1.286-.187,2.651-.431,4.018-.735,1.309-.319,2.758-.847,3.334-1.986a2.985,2.985,0,0,0-.906-3.434,7.689,7.689,0,0,0-3.517-1.541c-2.54-.569-4.882-.888-6.851-1.132C511.034,416.5,508.575,416.256,508.588,416.088Z",
    transform: "translate(-505.561 -415.978)",
    fill: "#ff9a6c"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_378",
    "data-name": "Group 378",
    transform: "translate(35.764 36.38)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_80",
    "data-name": "Path 80",
    d: "M511.765,421.436a14.9,14.9,0,0,1,3.544-.334,5.084,5.084,0,0,1,3.256,1.311,3.332,3.332,0,0,1,.912,3.352,4.468,4.468,0,0,1-2.939,2.425c-3.3,1.177-6.888,1.074-10.381.957",
    transform: "translate(-506.158 -420.714)",
    fill: "#ffbf9d"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_377",
    "data-name": "Group 377"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_81",
    "data-name": "Path 81",
    d: "M506.158,429.347c0-.166,1.415-.218,3.663-.334a30.656,30.656,0,0,0,3.893-.435,11.22,11.22,0,0,0,4.321-1.585,2.489,2.489,0,0,0,1.052-1.761,2.946,2.946,0,0,0-.568-1.9,4.541,4.541,0,0,0-3.137-1.623c-2.158-.185-3.6.142-3.617-.069-.013-.091,1.29-.7,3.678-.722a5.1,5.1,0,0,1,3.868,1.781,3.938,3.938,0,0,1,.839,2.621,3.559,3.559,0,0,1-1.463,2.574,11.069,11.069,0,0,1-4.811,1.71,22.582,22.582,0,0,1-4.043.207C507.544,429.72,506.154,429.491,506.158,429.347Z",
    transform: "translate(-506.158 -420.913)",
    fill: "#ff9a6c"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_379",
    "data-name": "Group 379",
    transform: "translate(22.273 1.658)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_82",
    "data-name": "Path 82",
    d: "M500.085,404.807c.119.017-.1.836.01,2.279a4.806,4.806,0,0,0,.939,2.337,6.2,6.2,0,0,0,2.789,1.787,33.162,33.162,0,0,0,4.079,1.056,41.627,41.627,0,0,0,4.77,1.015c3.4.5,7.22.854,11.243,1.138l.422.03.081.466c.148.843.221,1.757.445,2.652a30.541,30.541,0,0,0,5.047,11.2,40.411,40.411,0,0,0,6.872,7.332c4.432,3.65,7.711,5.122,7.609,5.318a9.76,9.76,0,0,1-2.307-.981,38.486,38.486,0,0,1-12.975-11.049,30.618,30.618,0,0,1-5.308-11.583c-.232-.931-.309-1.888-.459-2.768l.5.5c-4.054-.3-7.871-.688-11.322-1.261a39.79,39.79,0,0,1-4.818-1.134,31.532,31.532,0,0,1-4.139-1.218,6.684,6.684,0,0,1-2.985-2.13,5.078,5.078,0,0,1-.885-2.678,6.71,6.71,0,0,1,.2-1.735C499.987,404.995,500.052,404.8,500.085,404.807Z",
    transform: "translate(-499.695 -404.807)",
    fill: "#ff9a6c"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_83",
    "data-name": "Path 83",
    d: "M625.94,406.232l-86.164,9.858,3.829,51.515,104.132,6.065Z",
    transform: "translate(-433.838 -401.502)",
    fill: "#ff725e"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_382",
    "data-name": "Group 382",
    transform: "translate(168.354 305.107)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_84",
    "data-name": "Path 84",
    d: "M610.263,457.557q-3.551-13.915-7.1-27.83c-1.142-4.48-2.336-9.072-4.968-12.823s-7.986-11.085-12.411-10.333l-16.1,2.046c.562,8.684,1.536,17.8,2.33,26.54s3.333,17.529,8.615,24.413,13.578,11.616,22.066,11.085c2.814-.175,5.853-1.1,7.4-3.531C611.826,464.37,611.077,460.739,610.263,457.557Z",
    transform: "translate(-569.678 -406.518)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_384",
    "data-name": "Group 384",
    transform: "translate(175.437 198.848)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_85",
    "data-name": "Path 85",
    d: "M741.039,431.221c-7.439,20.58-90.448,79.065-90.448,79.065s-25.846,16.984-40.858,17.3c-19.4.412-35.369-16.7-35.467-33.732-.127-21.875-.935-106.442-.935-106.442l53.773-2.542V446.6s41.027-41.442,50.728-52.8c18.822-22.05,37.8-42.095,53.656-35.106",
    transform: "translate(-572.788 -357.178)",
    fill: "#ff725e"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_383",
    "data-name": "Group 383"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_86",
    "data-name": "Path 86",
    d: "M731.77,358.738s-.845-.226-2.442-.733a16.78,16.78,0,0,0-3.064-.481,8.77,8.77,0,0,0-1.987.011,12.688,12.688,0,0,0-2.265.222c-6.475.968-14.914,6.222-23.777,14.733-4.469,4.238-9.132,9.251-14.05,14.86l-7.629,8.813q-4.039,4.511-8.494,9.208c-11.846,12.547-25.437,26.48-40.349,41.623l-.791.8v-1.147c-.017-18.894-.033-39.747-.052-61.726l.541.532-53.771,2.568.516-.563c.1,11.109.2,22.852.309,34.756.175,20.422.347,40.359.511,59.615q.031,3.609.061,7.188c.04,2.376-.023,4.786.18,7.073a31.7,31.7,0,0,0,4.141,12.991,36.328,36.328,0,0,0,19.832,16.371,32.082,32.082,0,0,0,12.318,1.55,47.514,47.514,0,0,0,11.838-2.966,142.658,142.658,0,0,0,21.243-10.387,96.584,96.584,0,0,0,9.475-6.133l8.857-6.409q8.654-6.325,16.484-12.284c20.866-15.843,37.182-29.481,47.695-39.766A99.5,99.5,0,0,0,738.343,436.4a21.676,21.676,0,0,0,1.4-2.145,11.053,11.053,0,0,0,.9-1.626c.426-.9.672-1.36.672-1.36a20.873,20.873,0,0,1-2.8,5.262,95.06,95.06,0,0,1-11.134,12.842c-10.445,10.4-26.706,24.152-47.53,40.09q-7.809,5.976-16.457,12.351-4.337,3.159-8.844,6.442a97.448,97.448,0,0,1-9.525,6.2,143.054,143.054,0,0,1-21.366,10.508,48.33,48.33,0,0,1-12.082,3.046,33.027,33.027,0,0,1-12.7-1.574,37.318,37.318,0,0,1-20.421-16.809,32.822,32.822,0,0,1-4.3-13.444c-.211-2.423-.146-4.769-.188-7.162q-.034-3.577-.067-7.188c-.171-19.256-.351-39.191-.534-59.611-.1-11.907-.2-23.647-.3-34.756l0-.539.52-.024,53.771-2.52.543-.026v.561c-.019,21.979-.038,42.832-.052,61.726l-.791-.343c14.939-15.1,28.572-28.992,40.456-41.483q4.459-4.682,8.516-9.156,3.977-4.556,7.665-8.774c4.953-5.592,9.656-10.592,14.171-14.817,8.951-8.483,17.515-13.72,24.1-14.61a12.921,12.921,0,0,1,2.3-.19,8.762,8.762,0,0,1,2.012.026,15.955,15.955,0,0,1,3.083.558C730.964,358.417,731.77,358.738,731.77,358.738Z",
    transform: "translate(-573.071 -357.229)",
    fill: "#263238"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_385",
    "data-name": "Group 385",
    transform: "translate(189.461 291.956)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_87",
    "data-name": "Path 87",
    d: "M579.8,440.359a6.572,6.572,0,0,1,.626-1.809c.463-1.136,1.2-2.749,2.158-4.713a136.275,136.275,0,0,1,8.508-14.8,134.654,134.654,0,0,1,10.251-13.569c1.423-1.641,2.609-2.934,3.467-3.792s1.349-1.313,1.4-1.259c.121.116-1.6,2.171-4.285,5.566s-6.285,8.171-9.938,13.687-6.642,10.719-8.727,14.537S579.949,440.435,579.8,440.359Z",
    transform: "translate(-579.789 -400.418)",
    fill: "#ff725e"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_88",
    "data-name": "Path 88",
    d: "M747.69,359.4h0a14.452,14.452,0,0,0-17.252,11.316L690.922,556.482l28.9.067,38.827-179.326A14.938,14.938,0,0,0,747.69,359.4Z",
    transform: "translate(-269.485 -156.284)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_386",
    "data-name": "Group 386",
    transform: "translate(237.439 177.158)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_89",
    "data-name": "Path 89",
    d: "M603.976,347.168c.3.024.328,2.768.063,6.129s-.72,6.064-1.021,6.039-.328-2.768-.063-6.129S603.678,347.142,603.976,347.168Z",
    transform: "translate(-602.774 -347.168)",
    fill: "#ff9a6c"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_387",
    "data-name": "Group 387",
    transform: "translate(229.018 287.455)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_90",
    "data-name": "Path 90",
    d: "M599.283,436.3c-.15-.019-.284-2.16-.382-5.6s-.161-8.184-.161-13.416.06-9.971.159-13.4.234-5.553.384-5.556.286,2.126.384,5.566.159,8.2.159,13.452-.063,10-.161,13.433S599.431,436.32,599.283,436.3Z",
    transform: "translate(-598.74 -398.33)",
    fill: "#263238"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Character_2",
    "data-name": "Character 2",
    transform: "translate(287.419 254.693)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_567",
    "data-name": "Group 567"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_393",
    "data-name": "Group 393",
    transform: "translate(438.189 286.851)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_91",
    "data-name": "Path 91",
    d: "M356.8,308.694l9.333-5.888s12.211-11.232,15.534-13.681,16.156-8.416,17.966-8.266,19.442-1,23.631-3.012,8.717-4.663,8.717-4.663a6.814,6.814,0,0,1,.451,7.817c-2.519,4.482-15.4,12.939-15.4,12.939l4.836,32.56s-12,9.777-19.484,10.419-14.678-.88-16.791-.2-7.366,2.6-7.366,2.6Z",
    transform: "translate(-356.8 -254.74)",
    fill: "#ffbf9d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_92",
    "data-name": "Path 92",
    d: "M372.79,320.729l81.891-56.1,4.65,7.064L378.2,327.549Z",
    transform: "translate(-339.413 -264.629)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_390",
    "data-name": "Group 390",
    transform: "translate(38.172 36.323)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_93",
    "data-name": "Path 93",
    d: "M416.01,284.486s6.3,2.632,2.954,8.535-7.592,4.062-7.592,4.062,1.538,6.377-5.536,9.815c0,0,.812,6.185-4.133,9.831l-3.979,2.128-2.538-5.062s-14.983-1.414-17.244-7.578l-.111-3.2s-2.92-1.524-2.434-4.527.286-3.068,5.928-5.055,17.592-.666,17.592-.666-6.414-2.531-6.3-5.952,2.668-5.605,9.556-5.109A66.556,66.556,0,0,1,416.01,284.486Z",
    transform: "translate(-374.809 -281.291)",
    fill: "#ffbf9d"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_389",
    "data-name": "Group 389"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_94",
    "data-name": "Path 94",
    d: "M416.288,284.673a22.981,22.981,0,0,1-2.476-.569c-1.607-.382-3.972-.938-7.016-1.395a47.2,47.2,0,0,0-5.056-.5,13.53,13.53,0,0,0-5.767.789,4.282,4.282,0,0,0-2.219,2.055,3.871,3.871,0,0,0-.165,3.137,6.981,6.981,0,0,0,2.423,2.522,18.289,18.289,0,0,0,3.35,1.8l2.87,1.192-3.087-.259a64.042,64.042,0,0,0-14.712.06,18.311,18.311,0,0,0-3.778,1.039,14.491,14.491,0,0,0-3.567,1.628,2.4,2.4,0,0,0-.712,1.57l-.173,1.058a3.862,3.862,0,0,0-.019.931,4.207,4.207,0,0,0,2.169,2.982l.288.164.01.317c.036,1.011.073,2.1.111,3.2l-.033-.179c.117.224.242.47.369.714a8.816,8.816,0,0,0,3.375,2.958,23.3,23.3,0,0,0,4.252,1.757,48.279,48.279,0,0,0,8.786,1.809l.29.032.127.259q1.287,2.581,2.526,5.066l-.689-.226q2.035-1.08,3.985-2.115l-.058.039a10.506,10.506,0,0,0,3.974-9.35l-.029-.343.284-.14a9.861,9.861,0,0,0,4.457-3.975,8.151,8.151,0,0,0,.908-5.327l-.119-.681.626.233a4.815,4.815,0,0,0,3.87-.362,8.123,8.123,0,0,0,2.716-2.524,10.059,10.059,0,0,0,1.453-2.951,4.894,4.894,0,0,0-.1-2.7,6.324,6.324,0,0,0-2.332-2.947c-.708-.517-1.127-.718-1.113-.754a3.363,3.363,0,0,1,1.229.574,6.23,6.23,0,0,1,2.6,2.982,5.292,5.292,0,0,1,.207,2.966,10.5,10.5,0,0,1-1.461,3.184,8.687,8.687,0,0,1-2.883,2.785,5.446,5.446,0,0,1-4.471.461l.505-.448a8.93,8.93,0,0,1-.908,5.933,10.709,10.709,0,0,1-4.8,4.4l.255-.485a12.566,12.566,0,0,1-.747,5.584,10.592,10.592,0,0,1-3.542,4.728l-.027.019-.033.019q-1.947,1.048-3.974,2.141l-.451.244-.238-.47q-1.249-2.48-2.549-5.055l.417.289a48.621,48.621,0,0,1-9-1.822,24.253,24.253,0,0,1-4.448-1.832,9.824,9.824,0,0,1-3.8-3.37c-.154-.306-.311-.612-.453-.893l-.031-.063,0-.118c-.038-1.1-.075-2.186-.109-3.2l.3.481a5.29,5.29,0,0,1-2.751-3.848,4.958,4.958,0,0,1,.027-1.244l.177-1.084a3.522,3.522,0,0,1,1.081-2.212,14.672,14.672,0,0,1,3.908-1.811,19.419,19.419,0,0,1,3.964-1.069,63.544,63.544,0,0,1,14.975.037l-.217.936a19.127,19.127,0,0,1-3.523-1.932,7.829,7.829,0,0,1-2.695-2.913,4.952,4.952,0,0,1,2.862-6.3,14.023,14.023,0,0,1,6.1-.744,45.335,45.335,0,0,1,5.112.63,61.983,61.983,0,0,1,7,1.666c.8.239,1.4.444,1.8.593A2,2,0,0,1,416.288,284.673Z",
    transform: "translate(-375.087 -281.478)",
    fill: "#ff9a6c"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_391",
    "data-name": "Group 391",
    transform: "translate(41.085 56.641)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_95",
    "data-name": "Path 95",
    d: "M402.859,296.355c-.148.328-5.525-2.82-12.912-3.934-7.375-1.2-13.416.153-13.464-.207-.029-.129,1.436-.642,3.906-1a33.667,33.667,0,0,1,19.033,2.988C401.674,295.3,402.926,296.241,402.859,296.355Z",
    transform: "translate(-376.483 -290.903)",
    fill: "#ff9a6c"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_392",
    "data-name": "Group 392",
    transform: "translate(60.419 47.841)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_96",
    "data-name": "Path 96",
    d: "M399.833,291.527c-.182.239-2.945-1.638-6.874-2.729-3.9-1.166-7.224-1.4-7.214-1.731-.017-.289,3.446-.561,7.512.653C397.37,288.861,400.056,291.3,399.833,291.527Z",
    transform: "translate(-385.745 -286.821)",
    fill: "#ff9a6c"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_546",
    "data-name": "Group 546",
    transform: "translate(106.588)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_398",
    "data-name": "Group 398",
    transform: "translate(47.58)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_397",
    "data-name": "Group 397"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_396",
    "data-name": "Group 396"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_395",
    "data-name": "Group 395"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_394",
    "data-name": "Group 394"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_97",
    "data-name": "Path 97",
    d: "M222.068,143.5a13.948,13.948,0,0,1,14.457-7.694,18.74,18.74,0,0,1,23.675-.039,16.949,16.949,0,0,1,16.851-.692,18.046,18.046,0,0,1,9.23,14.578,14.536,14.536,0,0,1,15.081,7.464,15.552,15.552,0,0,1-2.108,17.132c6.442,2.011,10.8,9.473,9.508,16.294s-8.039,12.047-14.741,11.409l-69.061-41.922A14.872,14.872,0,0,1,222.068,143.5Z",
    transform: "translate(-220.734 -131.571)",
    fill: "#263238"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_533",
    "data-name": "Group 533",
    transform: "translate(0 6.66)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_526",
    "data-name": "Group 526",
    transform: "translate(0.391 7.546)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_405",
    "data-name": "Group 405",
    transform: "translate(14.865 4.008)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_404",
    "data-name": "Group 404"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_403",
    "data-name": "Group 403"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_402",
    "data-name": "Group 402"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_401",
    "data-name": "Group 401"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_400",
    "data-name": "Group 400"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_399",
    "data-name": "Group 399"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_98",
    "data-name": "Path 98",
    d: "M312.9,194.127c-3.062-31.2-28.814-54.741-59.175-54.094l-3.016.065c-32.49,2.656-48.458,32.635-44.989,66.1l6.943,111.773,4.74,13.976,55.969,72.436,14.109-65.255.269-30.3s31.173-5.687,30.914-37.986C318.534,255.249,315.747,223.149,312.9,194.127Z",
    transform: "translate(-205.249 -140.02)",
    fill: "#ffbf9d"
  })))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_414",
    "data-name": "Group 414",
    transform: "translate(56.405 161.259)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_413",
    "data-name": "Group 413"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_412",
    "data-name": "Group 412"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_411",
    "data-name": "Group 411"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_410",
    "data-name": "Group 410"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_409",
    "data-name": "Group 409"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_408",
    "data-name": "Group 408"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_407",
    "data-name": "Group 407"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_406",
    "data-name": "Group 406"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_99",
    "data-name": "Path 99",
    d: "M266.068,224.573s-19.646,1.565-40.919-11.611c0,0,10.042,23.1,40.885,19.622Z",
    transform: "translate(-225.149 -212.962)",
    fill: "#ff9a6c"
  })))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_426",
    "data-name": "Group 426",
    transform: "translate(105.145 84.135)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_425",
    "data-name": "Group 425"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_424",
    "data-name": "Group 424"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_423",
    "data-name": "Group 423"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_422",
    "data-name": "Group 422"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_421",
    "data-name": "Group 421"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_420",
    "data-name": "Group 420"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_419",
    "data-name": "Group 419"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_418",
    "data-name": "Group 418"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_417",
    "data-name": "Group 417"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_416",
    "data-name": "Group 416"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_415",
    "data-name": "Group 415"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_100",
    "data-name": "Path 100",
    d: "M257.4,181.265a4.559,4.559,0,0,1-4.212,4.743,4.315,4.315,0,0,1-4.686-4.059,4.56,4.56,0,0,1,4.208-4.747A4.319,4.319,0,0,1,257.4,181.265Z",
    transform: "translate(-248.499 -177.188)",
    fill: "#263238"
  }))))))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_439",
    "data-name": "Group 439",
    transform: "translate(98.838 71.025)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_438",
    "data-name": "Group 438"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_437",
    "data-name": "Group 437"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_436",
    "data-name": "Group 436"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_435",
    "data-name": "Group 435"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_434",
    "data-name": "Group 434"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_433",
    "data-name": "Group 433"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_432",
    "data-name": "Group 432"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_431",
    "data-name": "Group 431"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_430",
    "data-name": "Group 430"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_429",
    "data-name": "Group 429"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_428",
    "data-name": "Group 428"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_427",
    "data-name": "Group 427"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_101",
    "data-name": "Path 101",
    d: "M263.127,175.771c-.541.614-3.972-1.9-8.78-1.785-4.8.043-8.274,2.673-8.807,2.076-.263-.265.28-1.362,1.791-2.548a12,12,0,0,1,7.039-2.406,11.516,11.516,0,0,1,7,2.171C262.875,174.419,263.4,175.495,263.127,175.771Z",
    transform: "translate(-245.477 -171.106)",
    fill: "#263238"
  })))))))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_451",
    "data-name": "Group 451",
    transform: "translate(64.009 87.136)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_450",
    "data-name": "Group 450"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_449",
    "data-name": "Group 449"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_448",
    "data-name": "Group 448"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_447",
    "data-name": "Group 447"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_446",
    "data-name": "Group 446"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_445",
    "data-name": "Group 445"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_444",
    "data-name": "Group 444"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_443",
    "data-name": "Group 443"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_442",
    "data-name": "Group 442"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_441",
    "data-name": "Group 441"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_440",
    "data-name": "Group 440"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_102",
    "data-name": "Path 102",
    d: "M237.7,182.657a4.555,4.555,0,0,1-4.212,4.743,4.315,4.315,0,0,1-4.686-4.059,4.563,4.563,0,0,1,4.208-4.747A4.318,4.318,0,0,1,237.7,182.657Z",
    transform: "translate(-228.792 -178.58)",
    fill: "#263238"
  }))))))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_464",
    "data-name": "Group 464",
    transform: "translate(52.857 71.312)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_463",
    "data-name": "Group 463"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_462",
    "data-name": "Group 462"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_461",
    "data-name": "Group 461"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_460",
    "data-name": "Group 460"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_459",
    "data-name": "Group 459"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_458",
    "data-name": "Group 458"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_457",
    "data-name": "Group 457"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_456",
    "data-name": "Group 456"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_455",
    "data-name": "Group 455"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_454",
    "data-name": "Group 454"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_453",
    "data-name": "Group 453"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_452",
    "data-name": "Group 452"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_103",
    "data-name": "Path 103",
    d: "M241.1,175.9c-.543.614-3.981-1.9-8.782-1.783-4.8.043-8.276,2.671-8.809,2.074-.263-.263.276-1.36,1.793-2.548a12.012,12.012,0,0,1,7.037-2.406,11.528,11.528,0,0,1,7.005,2.173C240.843,174.552,241.369,175.63,241.1,175.9Z",
    transform: "translate(-223.449 -171.239)",
    fill: "#263238"
  })))))))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_476",
    "data-name": "Group 476",
    transform: "translate(83.997 71.116)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_475",
    "data-name": "Group 475"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_474",
    "data-name": "Group 474"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_473",
    "data-name": "Group 473"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_472",
    "data-name": "Group 472"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_471",
    "data-name": "Group 471"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_470",
    "data-name": "Group 470"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_469",
    "data-name": "Group 469"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_468",
    "data-name": "Group 468"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_467",
    "data-name": "Group 467"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_466",
    "data-name": "Group 466"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_465",
    "data-name": "Group 465"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_104",
    "data-name": "Path 104",
    d: "M241.439,212.451c-.027-.285,2.947-.88,7.775-1.621,1.223-.157,2.38-.433,2.57-1.3.271-.921-.269-2.277-.893-3.738q-1.822-4.56-3.822-9.572c-5.312-13.629-9.184-24.848-8.652-25.064s5.273,10.656,10.585,24.288q1.923,5.041,3.67,9.632c.493,1.429,1.325,3.046.737,4.958a3.121,3.121,0,0,1-1.981,1.9,8.119,8.119,0,0,1-2.079.343C244.484,212.643,241.464,212.729,241.439,212.451Z",
    transform: "translate(-238.368 -171.149)",
    fill: "#263238"
  }))))))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_488",
    "data-name": "Group 488",
    transform: "translate(72.269 116.149)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_487",
    "data-name": "Group 487"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_486",
    "data-name": "Group 486"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_485",
    "data-name": "Group 485"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_484",
    "data-name": "Group 484"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_483",
    "data-name": "Group 483"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_482",
    "data-name": "Group 482"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_481",
    "data-name": "Group 481"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_480",
    "data-name": "Group 480"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_479",
    "data-name": "Group 479"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_478",
    "data-name": "Group 478"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_477",
    "data-name": "Group 477"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_105",
    "data-name": "Path 105",
    d: "M233.477,192.038c.781-.065.9,5.323,5.438,9.05s10.08,3.018,10.136,3.771c.079.336-1.217,1.071-3.563,1.188a12.711,12.711,0,0,1-8.454-2.841,11.788,11.788,0,0,1-4.225-7.6C232.565,193.36,233.12,192.015,233.477,192.038Z",
    transform: "translate(-232.749 -192.038)",
    fill: "#263238"
  }))))))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_496",
    "data-name": "Group 496",
    transform: "translate(50.781 57.19)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_495",
    "data-name": "Group 495"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_494",
    "data-name": "Group 494"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_493",
    "data-name": "Group 493"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_492",
    "data-name": "Group 492"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_491",
    "data-name": "Group 491"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_490",
    "data-name": "Group 490"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_489",
    "data-name": "Group 489"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_106",
    "data-name": "Path 106",
    d: "M241.962,169.3c-.545,1.3-4.7.233-9.731.425-5.031.073-9.193,1.362-9.736.091-.238-.608.58-1.8,2.321-2.934a14.67,14.67,0,0,1,7.421-2.188,14.04,14.04,0,0,1,7.412,1.8C241.388,167.533,242.2,168.682,241.962,169.3Z",
    transform: "translate(-222.455 -164.689)",
    fill: "#263238"
  }))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_504",
    "data-name": "Group 504",
    transform: "translate(98.755 57.809)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_503",
    "data-name": "Group 503"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_502",
    "data-name": "Group 502"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_501",
    "data-name": "Group 501"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_500",
    "data-name": "Group 500"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_499",
    "data-name": "Group 499"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_498",
    "data-name": "Group 498"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_497",
    "data-name": "Group 497"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_107",
    "data-name": "Path 107",
    d: "M261.812,169.27c-.731,1.212-4.139.4-8.105.765-3.976.224-7.237,1.531-8.126.442-.395-.535.021-1.714,1.38-2.932a11.48,11.48,0,0,1,13.079-.97C261.553,167.578,262.127,168.686,261.812,169.27Z",
    transform: "translate(-245.438 -164.976)",
    fill: "#263238"
  }))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_511",
    "data-name": "Group 511",
    transform: "translate(7.34)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_510",
    "data-name": "Group 510"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_509",
    "data-name": "Group 509"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_508",
    "data-name": "Group 508"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_507",
    "data-name": "Group 507"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_506",
    "data-name": "Group 506"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_505",
    "data-name": "Group 505"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_108",
    "data-name": "Path 108",
    d: "M313.513,181.53s-8.65-20.045-18.185-24.564c-11.543-5.469-16.206,7.593-27.161,4.68s-21.976-8.164-32.935.77c-11.994,9.779-6.152,16.335-6.619,30.677-1.893,58.154-11.835,74.8-15.3,47.5-.378-2.99-8.481-5.2-9.928-17.842-1.877-16.391-2.885-36.317.432-48.047,2.8-9.887,8.082-16.79,17.657-24.479,15.117-12.137,36.2-12.84,50.546-11.657S314.313,156.182,313.513,181.53Z",
    transform: "translate(-201.644 -138.161)",
    fill: "#263238"
  })))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_518",
    "data-name": "Group 518",
    transform: "translate(0 93.205)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_517",
    "data-name": "Group 517"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_516",
    "data-name": "Group 516"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_515",
    "data-name": "Group 515"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_514",
    "data-name": "Group 514"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_513",
    "data-name": "Group 513"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_512",
    "data-name": "Group 512"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_109",
    "data-name": "Path 109",
    d: "M219.109,189.7a8.577,8.577,0,0,0-9.333-8.25c-5.82.7-12.24,4.253-11.606,16.69,1.123,22.061,22.337,16.346,22.341,15.712C220.516,213.423,219.658,198.931,219.109,189.7Z",
    transform: "translate(-198.127 -181.395)",
    fill: "#ffbf9d"
  })))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_525",
    "data-name": "Group 525",
    transform: "translate(7.342 100.374)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_524",
    "data-name": "Group 524"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_523",
    "data-name": "Group 523"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_522",
    "data-name": "Group 522"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_521",
    "data-name": "Group 521"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_520",
    "data-name": "Group 520"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_519",
    "data-name": "Group 519"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_110",
    "data-name": "Path 110",
    d: "M211.617,201.962c-.1-.067-.359.289-.973.621a3.613,3.613,0,0,1-2.778.209c-2.3-.733-4.388-4.329-4.695-8.3a13.11,13.11,0,0,1,.762-5.56c.57-1.649,1.524-2.831,2.649-3.1a1.874,1.874,0,0,1,2.25.934c.317.6.2,1.048.319,1.08.063.052.438-.395.221-1.3a2.459,2.459,0,0,0-.912-1.337,2.737,2.737,0,0,0-2.085-.451c-1.641.207-3.043,1.854-3.713,3.633a13.465,13.465,0,0,0-.977,6.217c.363,4.439,2.778,8.479,5.914,9.233a3.9,3.9,0,0,0,3.373-.767C211.607,202.5,211.692,202,211.617,201.962Z",
    transform: "translate(-201.644 -184.72)",
    fill: "#ff9a6c"
  }))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_532",
    "data-name": "Group 532"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_531",
    "data-name": "Group 531"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_530",
    "data-name": "Group 530"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_529",
    "data-name": "Group 529"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_528",
    "data-name": "Group 528"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_527",
    "data-name": "Group 527"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_111",
    "data-name": "Path 111",
    d: "M218.876,200.938c2.816,1.9,5.788,3.852,9.141,4.124s7.137-1.8,7.634-5.23c.221-1.541-.177-3.316.777-4.525,1.14-1.442,3.3-1.043,5.1-.886,6.229.55,12.5-4.126,13.96-10.4,1.632,2.417,5.331,2.231,7.7.584s3.86-4.294,5.692-6.554,4.427-4.3,7.262-3.947c1.584.2,3.083,1.138,4.669.959,2.8-.317,4.106-3.742,4.473-6.629s.63-6.25,2.977-7.864c2.173-1.5,5.045-.72,7.638-.382s5.916-.358,6.525-2.982a5.372,5.372,0,0,0-1.035-3.984,13.6,13.6,0,0,0-16.451-5.066,19.374,19.374,0,0,0-16.3-13.429,19.113,19.113,0,0,0-18.252,10.406,18.922,18.922,0,0,0-17.121-4.245,19.6,19.6,0,0,0-13.176,12.064,13.91,13.91,0,0,0-14.319,5.359,15.007,15.007,0,0,0-.829,15.707c-3.8,2.348-7.009,6.362-7,10.934s4.413,9.031,8.656,7.737A8.333,8.333,0,0,0,209.819,203a7.785,7.785,0,0,0,10.157-2.719",
    transform: "translate(-197.94 -134.661)",
    fill: "#263238"
  })))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_539",
    "data-name": "Group 539",
    transform: "translate(7.026 64.671)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_538",
    "data-name": "Group 538"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_537",
    "data-name": "Group 537"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_536",
    "data-name": "Group 536"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_535",
    "data-name": "Group 535"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_534",
    "data-name": "Group 534"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_112",
    "data-name": "Path 112",
    d: "M201.368,161.571c-.075-.056-.357,1.865,1.415,4.217a6.837,6.837,0,0,0,4.338,2.546,7.25,7.25,0,0,0,6.058-1.96l-.908-.121a21.913,21.913,0,0,0,4.377,5.415,12.171,12.171,0,0,0,3.945,2.417,8.076,8.076,0,0,0,4.31.323,8.383,8.383,0,0,0,6.1-3.786,13,13,0,0,0,1.639-4.631,4.469,4.469,0,0,0,.129-1.787c-.092-.019-.261.591-.595,1.669a15.011,15.011,0,0,1-1.889,4.241c-1.964,3.21-8.533,4.967-12.839.584a22.042,22.042,0,0,1-4.173-5.073l-.388-.642-.518.522a6.371,6.371,0,0,1-5.12,1.807,6.246,6.246,0,0,1-3.912-2.024C201.577,163.313,201.554,161.51,201.368,161.571Z",
    transform: "translate(-201.306 -161.569)",
    fill: "#455a64"
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_545",
    "data-name": "Group 545",
    transform: "translate(46.473 4.588)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_544",
    "data-name": "Group 544"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_543",
    "data-name": "Group 543"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_542",
    "data-name": "Group 542"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_541",
    "data-name": "Group 541"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_540",
    "data-name": "Group 540"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_113",
    "data-name": "Path 113",
    d: "M220.2,142.505c-.01.075.559.142,1.522.539a7.394,7.394,0,0,1,3.379,2.846l.263.414.288-.416a26.911,26.911,0,0,1,10.163-8.863,20.244,20.244,0,0,1,8.377-2.085,16.937,16.937,0,0,1,9.105,2.477,17.856,17.856,0,0,1,5.5,5.163,15.237,15.237,0,0,1,2.484,6.605l.081.7.643-.2a11.656,11.656,0,0,1,8.907.927,11.924,11.924,0,0,1,4.966,5.275c1.8,3.846,1.246,6.545,1.463,6.511a4.593,4.593,0,0,0,.223-1.811,12.614,12.614,0,0,0-1.065-5.006,12.335,12.335,0,0,0-14.816-7.022l.724.5a16.242,16.242,0,0,0-2.62-7.19,18.8,18.8,0,0,0-5.868-5.551,17.871,17.871,0,0,0-9.752-2.611,20.932,20.932,0,0,0-8.815,2.315,26.313,26.313,0,0,0-10.249,9.477h.551a7.283,7.283,0,0,0-3.814-2.8A3.089,3.089,0,0,0,220.2,142.505Z",
    transform: "translate(-220.204 -133.699)",
    fill: "#455a64"
  })))))))), /*#__PURE__*/React.createElement("path", {
    id: "Path_114",
    "data-name": "Path 114",
    d: "M187.191,543.27l.754-116.085,15.816-42.348.021-11.424,178.636-3.1v13.309l20.5,52.632,1.094,107.011H300.831l-8.62-48.329-1.99,48.329Z",
    transform: "translate(-103.04 144.379)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_559",
    "data-name": "Group 559",
    transform: "translate(0 187.156)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_115",
    "data-name": "Path 115",
    d: "M218.353,218.385l37.283,30.164,23.612,30.964,8.635-32.1,6.187-25.178,10.153,10.4,25.737,56.6,28.948,273.59s-50.492,15.274-76.644,17.126-67.831-5.553-67.831-5.553V430.456L199.59,287.9l17.9-54.627Z",
    transform: "translate(-89.558 -218.385)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_547",
    "data-name": "Group 547",
    transform: "translate(189.231 62.476)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_116",
    "data-name": "Path 116",
    d: "M252.44,544.637a3.967,3.967,0,0,1-.073-.767c-.027-.565-.063-1.311-.109-2.253-.071-2.05-.175-4.958-.3-8.669-.248-7.6-.6-18.473-1.042-31.883-.9-26.92-2.336-64.1-4.388-105.14s-4.352-78.19-6.145-105.062c-.9-13.383-1.639-24.238-2.15-31.82-.24-3.7-.428-6.608-.562-8.653-.05-.944-.09-1.688-.119-2.253a4.088,4.088,0,0,1,0-.772,3.951,3.951,0,0,1,.115.763l.227,2.244c.18,2.042.436,4.939.764,8.636.647,7.5,1.5,18.368,2.5,31.8,1.987,26.86,4.4,64,6.463,105.062,2.052,41.049,3.363,78.242,4.07,105.172.357,13.463.591,24.363.7,31.9.044,3.712.079,6.623.1,8.673v2.257A4.025,4.025,0,0,1,252.44,544.637Z",
    transform: "translate(-237.532 -247.365)",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_117",
    "data-name": "Path 117",
    d: "M247.077,230.208l-8.631,12.269L167.84,280.862l39.3,123.773,10.585,69.42-39.7,164.908s48.162,17.113,52.4,11.648c1.781-2.3,6.834-14.164,12.1-27.144a298.69,298.69,0,0,0,20.22-80.988c2.947-28.075,5.653-63.862,3.672-88.1-3.705-45.37-9.527-120.254-10.055-139.933s-3.9-93.977-3.9-93.977Z",
    transform: "translate(-124.082 -215.98)",
    fill: "#ff725e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_118",
    "data-name": "Path 118",
    d: "M247.243,221.6l23.368,14.093,75.647,25.676L340.2,316.629l-3.471,142.994,23.817,171.634s-25.4,9.294-35.46,5.467-23.817-27.332-24.345-41.543-20.112-151.958-20.112-151.958l-19.054-185.3Z",
    transform: "translate(-37.741 -214.667)",
    fill: "#ff725e"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_548",
    "data-name": "Group 548",
    transform: "translate(234.309 20.95)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_119",
    "data-name": "Path 119",
    d: "M259.129,228.1a8.631,8.631,0,0,1,.95,1.1c.645.817,1.513,1.914,2.613,3.309,2.313,2.99,5.592,7.233,9.71,12.562l.207.267-.267.211c-2.459,1.925-5.233,4.1-8.229,6.452l-.115-.7c3,.981,6.243,2.039,9.656,3.156l.3.1,0,.332c-.184,17.777-.413,40.157-.664,64.418-.419,29.612-.8,56.414-1.073,75.922-.188,9.645-.342,17.482-.449,23.007-.075,2.645-.136,4.734-.177,6.254-.031.66-.054,1.194-.073,1.626a2.132,2.132,0,0,1-.063.554,2.128,2.128,0,0,1-.05-.556c-.008-.431-.021-.966-.034-1.626-.006-1.52-.017-3.611-.027-6.258.025-5.525.061-13.364.1-23.009.194-19.51.459-46.312.754-75.926.334-24.262.641-46.641.885-64.416l.3.431-9.629-3.245-.716-.241.6-.461,8.3-6.351-.063.479c-4.016-5.409-7.216-9.721-9.47-12.756l-2.48-3.417A8.7,8.7,0,0,1,259.129,228.1Z",
    transform: "translate(-259.127 -228.103)",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_549",
    "data-name": "Group 549",
    transform: "translate(106.431 12.311)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_120",
    "data-name": "Path 120",
    d: "M231.618,426.667a2.178,2.178,0,0,1-.2-.533l-.505-1.593c-.465-1.483-1.108-3.531-1.925-6.127-1.691-5.314-4.2-12.98-7.417-22.414-1.632-4.715-3.419-9.872-5.335-15.4-1.985-5.508-3.812-11.555-5.425-17.967a418.157,418.157,0,0,1-7.583-42.351c-2.62-19.7-4.315-38.283-5.346-54.267l-.015-.224.157-.157q4.38-4.359,8.322-8.287l.04.679-7.888-6.2-.309-.241.228-.317c5.976-8.369,10.829-15.164,14.246-19.948,1.662-2.285,2.97-4.087,3.918-5.387.426-.565.768-1.022,1.042-1.386a2.286,2.286,0,0,1,.386-.448,2.3,2.3,0,0,1-.294.517l-.952,1.453-3.751,5.515-13.962,20.159-.079-.561c2.488,1.923,5.125,3.956,7.94,6.129l.4.313-.363.367-8.266,8.345.142-.382c1.119,15.945,2.864,34.508,5.479,54.176,2.044,15.1,4.4,29.44,7.477,42.252q2.376,9.6,5.3,17.9c1.872,5.549,3.615,10.723,5.212,15.457,3.127,9.471,5.525,17.184,7.093,22.541.785,2.68,1.361,4.771,1.733,6.194.163.662.294,1.2.4,1.626A2.334,2.334,0,0,1,231.618,426.667Z",
    transform: "translate(-197.865 -224.096)",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_121",
    "data-name": "Path 121",
    d: "M184.986,380.083l41.075,16.638,2.739-9.453,13.954,13.18,2.5-22.91-12.876-24.8-44.387,14.851Z",
    transform: "translate(-105.438 -63.095)",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_554",
    "data-name": "Group 554",
    transform: "translate(115.993 262.785)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_122",
    "data-name": "Path 122",
    d: "M305.548,394.156l-16.67-10.449L274.233,370a36.693,36.693,0,0,0,11.393,6.4c6.863,2.365,10.733-4.146,10.733-4.146s-6.005-3.915-8.066-5.1-22.844-17.193-28.109-18.374-40.011-8.5-40.011-8.5l-.553,1.856-17.175,37.811,15.265,4.232a105.711,105.711,0,0,1,7.78,13.235c3.432,7.09,20.087,14.08,26.5,17.557s13.66-2.611,13.66-2.611c7.366,1.744,9.189-6.433,9.189-6.433,8.466-1.183,9.189-10.7,9.189-10.7s15.371,6.153,20.11,7.017a2.879,2.879,0,0,0,3.492-1.9A5.115,5.115,0,0,0,305.548,394.156Z",
    transform: "translate(-202.446 -340.28)",
    fill: "#ffbf9d"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_550",
    "data-name": "Group 550",
    transform: "translate(63.2 43.999)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_123",
    "data-name": "Path 123",
    d: "M251.108,371.634c-.121.257-4.548-1.574-9.717-4.508-5.193-2.921-8.857-6.185-8.661-6.422s4.06,2.555,9.189,5.441C247.032,369.049,251.252,371.334,251.108,371.634Z",
    transform: "translate(-232.723 -360.689)",
    fill: "#ff9a6c"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_551",
    "data-name": "Group 551",
    transform: "translate(54.565 53.518)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_124",
    "data-name": "Path 124",
    d: "M228.59,365.127c.161-.289,4.546,2.236,9.577,5.866s9.155,6.452,9.015,6.711c-.152.285-4.584-2.154-9.629-5.786S228.452,365.377,228.59,365.127Z",
    transform: "translate(-228.586 -365.105)",
    fill: "#ff9a6c"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_552",
    "data-name": "Group 552",
    transform: "translate(47.936 60.835)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_125",
    "data-name": "Path 125",
    d: "M225.424,368.51c.2-.2,3.411,2.563,7.721,5.556,4.292,3.016,7.721,5.6,7.538,5.877-.159.235-3.828-1.914-8.155-4.954C228.171,371.966,225.19,368.736,225.424,368.51Z",
    transform: "translate(-225.411 -368.499)",
    fill: "#ff9a6c"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_553",
    "data-name": "Group 553",
    transform: "translate(52.223 14.6)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_126",
    "data-name": "Path 126",
    d: "M227.466,347.091c.025-.125,1.484.032,3.713.828a28.235,28.235,0,0,1,8.005,4.62,38.16,38.16,0,0,1,6.431,6.728c1.424,1.921,2.133,3.225,2.023,3.309-.292.241-3.626-4.667-9.124-9.154C233.035,348.85,227.361,347.416,227.466,347.091Z",
    transform: "translate(-227.464 -347.052)",
    fill: "#ff9a6c"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_127",
    "data-name": "Path 127",
    d: "M154.281,455.874a16.265,16.265,0,0,1-7.352-13.144,151.6,151.6,0,0,1,1.252-22.395c2.933-25.245,42.944-171.828,42.944-171.828L231.359,362.74l-13.816,49.733L287.95,447.29l-19.6,57.134S174.8,469.068,154.281,455.874Z",
    transform: "translate(-146.877 -183.569)",
    fill: "#ff725e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_128",
    "data-name": "Path 128",
    d: "M304.957,240.049l64.619,126.879,1.735,2.6,70.47-37.154,23.21,48.482-94.823,59.464a23.2,23.2,0,0,1-31.762-7.382l-41.908-64.6-11.272-53.1Z",
    transform: "translate(3.56 -193.345)",
    fill: "#ff725e"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_555",
    "data-name": "Group 555",
    transform: "translate(298.94 82.896)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_129",
    "data-name": "Path 129",
    d: "M291.624,256.837a8.888,8.888,0,0,1,.125,1.6c.038,1.158.085,2.682.148,4.585.071,4.109.173,9.841.3,16.872.177,14.246.248,33.931.046,55.668s-.643,41.426-1.085,55.668c-.255,7.028-.463,12.756-.612,16.861-.1,1.9-.175,3.426-.234,4.583a8.859,8.859,0,0,1-.155,1.6,8.924,8.924,0,0,1-.065-1.6c.008-1.158.017-2.682.029-4.588.065-4.107.157-9.837.267-16.867.246-14.244.564-33.92.768-55.659s.25-41.409.271-55.653c.021-7.03.035-12.765.048-16.871.023-1.9.042-3.43.056-4.588A8.844,8.844,0,0,1,291.624,256.837Z",
    transform: "translate(-290.09 -256.837)",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_556",
    "data-name": "Group 556",
    transform: "translate(59.839 96.672)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_130",
    "data-name": "Path 130",
    d: "M175.552,263.227a6.284,6.284,0,0,1,.447,1.281c.28.966.637,2.2,1.077,3.73.931,3.389,2.213,8.059,3.778,13.769,3.142,11.639,7.452,27.733,11.831,45.613s7.842,34.213,10.024,46.092c1.094,5.939,1.918,10.755,2.413,14.1.23,1.578.413,2.852.559,3.85a6.387,6.387,0,0,1,.121,1.356,6.366,6.366,0,0,1-.338-1.317c-.2-.987-.447-2.251-.758-3.812-.678-3.449-1.609-8.205-2.751-14.019-2.371-11.827-5.953-28.1-10.324-45.973s-8.567-33.987-11.518-45.68c-1.43-5.75-2.6-10.452-3.446-13.862-.359-1.55-.651-2.8-.879-3.786A6.466,6.466,0,0,1,175.552,263.227Z",
    transform: "translate(-175.544 -263.227)",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_557",
    "data-name": "Group 557",
    transform: "translate(30.72 226.746)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_131",
    "data-name": "Path 131",
    d: "M161.594,380.858a1.915,1.915,0,0,1,.457.136l1.317.485,5.07,1.962,18.92,7.507,65.178,26.223-.68.321c4.093-11.961,8.531-24.915,13.125-38.335,2.2-6.4,4.361-12.7,6.456-18.805l.276.688c-27-13.465-51.157-25.508-69.589-34.7l.048.022a39.156,39.156,0,0,0-28.6,1.248,51.013,51.013,0,0,0-7.06,3.835c-.726.494-1.3.884-1.741,1.181a3.458,3.458,0,0,1-.614.375,3.516,3.516,0,0,1,.549-.468l1.684-1.278a46.145,46.145,0,0,1,7.012-4.047,39.5,39.5,0,0,1,12.272-3.415,40.255,40.255,0,0,1,16.728,1.809l.025.009.025.013c18.469,9.115,42.666,21.058,69.723,34.413l.436.216-.163.47c-2.094,6.112-4.252,12.407-6.446,18.81-4.611,13.414-9.061,26.364-13.169,38.318l-.182.526-.5-.2-65.036-26.594-18.807-7.8q-3.206-1.358-5.01-2.126l-1.284-.569A1.837,1.837,0,0,1,161.594,380.858Z",
    transform: "translate(-161.594 -323.563)",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_558",
    "data-name": "Group 558",
    transform: "translate(370.142 174.89)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_132",
    "data-name": "Path 132",
    d: "M329.419,299.509c.132,0,.315,1.906.171,4.993a80,80,0,0,1-1.634,11.92c-.931,4.6-1.881,8.71-2.513,11.7s-1.029,4.846-1.188,4.82c-.138-.019-.019-1.923.432-4.967s1.277-7.209,2.2-11.782,1.611-8.725,1.933-11.758S329.25,299.509,329.419,299.509Z",
    transform: "translate(-324.201 -299.509)",
    fill: "#263238"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_560",
    "data-name": "Group 560",
    transform: "translate(367.488 365.11)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_133",
    "data-name": "Path 133",
    d: "M330.8,300.932c.294.093-1.113,5.312-3.407,11.523s-4.148,11.221-4.427,11.135,1.112-5.314,3.409-11.527S330.522,300.841,330.8,300.932Z",
    transform: "translate(-322.929 -300.93)",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_561",
    "data-name": "Group 561",
    transform: "translate(128.374 209.546)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_134",
    "data-name": "Path 134",
    d: "M268.817,266.358a14.917,14.917,0,0,1-1.983-1.852l-5.248-5.39c-4.54-4.79-10.687-11.275-17.726-18.7l.768-.026a22.9,22.9,0,0,0-4.571,10.046,23.131,23.131,0,0,0-.438,5.875l.071,1.263-.941-.789c-8.967-7.507-16.231-14.869-21.667-19.9-2.695-2.535-4.88-4.551-6.4-5.922a21.011,21.011,0,0,1-2.3-2.19,16.873,16.873,0,0,1,2.553,1.878c1.6,1.276,3.864,3.212,6.627,5.678,5.567,4.883,12.942,12.163,21.855,19.577l-.87.476a23.973,23.973,0,0,1,.449-6.176,23.711,23.711,0,0,1,4.843-10.538l.378-.453.392.425c6.932,7.539,12.986,14.121,17.457,18.982,2.054,2.292,3.738,4.174,5.031,5.618A15.28,15.28,0,0,1,268.817,266.358Z",
    transform: "translate(-208.377 -228.771)",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_562",
    "data-name": "Group 562",
    transform: "translate(190.346 206.231)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_135",
    "data-name": "Path 135",
    d: "M260.25,227.233a6.491,6.491,0,0,1,.086,1.723c-.006,1.119-.063,2.749-.215,4.8a103.9,103.9,0,0,1-2.628,16.509l-.328,1.356-.62-1.248a40.315,40.315,0,0,0-6.872-9.79c-.785-.823-1.595-1.6-2.384-2.3l.879-.3a156.708,156.708,0,0,1-6.41,21.867c-1.017,2.693-1.908,4.827-2.563,6.28a10.913,10.913,0,0,1-1.119,2.2,11.907,11.907,0,0,1,.749-2.361c.6-1.705,1.351-3.84,2.246-6.383a194.861,194.861,0,0,0,6.041-21.845l.194-.91.687.606c.814.72,1.649,1.518,2.457,2.367a39.905,39.905,0,0,1,7,10.1l-.948.108a126.627,126.627,0,0,0,2.991-16.313C259.971,229.63,260.121,227.227,260.25,227.233Z",
    transform: "translate(-238.066 -227.233)",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_564",
    "data-name": "Group 564",
    transform: "translate(276.813 490.833)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_136",
    "data-name": "Path 136",
    d: "M279.493,362l6.308,20.251,35.714-3.409-11.136-19.348Z",
    transform: "translate(-279.487 -358.963)",
    fill: "#ff725e"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_563",
    "data-name": "Group 563"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_137",
    "data-name": "Path 137",
    d: "M279.5,362.286a15.933,15.933,0,0,1,2.127-.28l6.254-.64c5.4-.537,13.2-1.3,22.466-2.089l.3-.028.157.274c3.39,5.855,7.181,12.4,11.182,19.318l.443.763-.86.082c-.578.056-1.2.116-1.833.175-12.844,1.179-24.642,2.264-33.891,3.111L285.5,383l-.1-.334c-1.918-6.325-3.411-11.482-4.423-15-.465-1.641-.845-2.977-1.146-4.031a8.53,8.53,0,0,1-.334-1.354,13.914,13.914,0,0,1,.549,1.483l1.38,4.075c1.188,3.615,2.812,8.561,4.782,14.558l-.443-.3,33.87-3.357,1.835-.175-.417.845c-3.97-6.935-7.727-13.5-11.09-19.376l.459.246c-9.038.69-16.689,1.186-22.149,1.529l-6.4.388C280.371,362.283,279.54,362.316,279.5,362.286Z",
    transform: "translate(-279.49 -359.248)",
    fill: "#263238"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_566",
    "data-name": "Group 566",
    transform: "translate(254.055 332.672)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_51",
    "data-name": "Rectangle 51",
    width: 38.374,
    height: 12.786,
    transform: "translate(0.543 0.613)",
    fill: "#ff725e"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_565",
    "data-name": "Group 565"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_138",
    "data-name": "Path 138",
    d: "M307.5,299.283a5.307,5.307,0,0,1-.073-.936c-.025-.7-.052-1.541-.088-2.553-.048-2.335-.113-5.456-.194-9.3l.355.366c-9.141.119-22.953.2-38.372.2.242-.25-.545.558.543-.561v.412l0,.414V289.8l0,3.24c0,2.134-.008,4.223-.012,6.245l-.528-.543c10.93.028,20.44.144,27.286.25,3.317.065,6.026.114,8.076.155a28.776,28.776,0,0,1,3.012.138,20.464,20.464,0,0,1-2.77.14l-7.955.153c-6.817.108-16.5.222-27.649.252H268.6v-.545c0-2.022-.008-4.111-.013-6.245l0-3.24v-3.3c1.085-1.123.3-.313.545-.563,15.419,0,29.232.075,38.372.2l.361,0-.008.36c-.079,3.932-.144,7.127-.194,9.516A28.923,28.923,0,0,1,307.5,299.283Z",
    transform: "translate(-268.587 -285.884)",
    fill: "#263238"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_139",
    "data-name": "Path 139",
    d: "M267.072,240.526l5.893,8.393s-1.645,127.239-7.9,158.833Z",
    transform: "translate(-18.367 -5.638)",
    opacity: 0.3
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Character_1",
    "data-name": "Character 1",
    transform: "translate(46.474 484.773)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_741",
    "data-name": "Group 741",
    transform: "translate(28.887)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_733",
    "data-name": "Group 733",
    transform: "translate(23.216)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_690",
    "data-name": "Group 690",
    transform: "translate(0 19.845)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_689",
    "data-name": "Group 689"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_688",
    "data-name": "Group 688"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_574",
    "data-name": "Group 574",
    transform: "translate(8.856)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_573",
    "data-name": "Group 573"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_572",
    "data-name": "Group 572"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_571",
    "data-name": "Group 571"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_570",
    "data-name": "Group 570"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_569",
    "data-name": "Group 569"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_568",
    "data-name": "Group 568"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_140",
    "data-name": "Path 140",
    d: "M177.048,307.256c.228-30.874-22.54-56.746-52.318-59.46l-2.958-.27c-32.068-.985-50.792,26.594-50.859,59.727l-7.07,116.465L60.652,447.5l73.678,19.53,6.25-50.3s31.089-2.128,34.177-33.762C176.247,367.691,176.838,335.97,177.048,307.256Z",
    transform: "translate(-60.652 -247.501)",
    fill: "#b56760"
  })))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_583",
    "data-name": "Group 583",
    transform: "translate(49.898 153.4)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_582",
    "data-name": "Group 582"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_581",
    "data-name": "Group 581"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_580",
    "data-name": "Group 580"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_579",
    "data-name": "Group 579"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_578",
    "data-name": "Group 578"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_577",
    "data-name": "Group 577"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_576",
    "data-name": "Group 576"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_575",
    "data-name": "Group 575"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_141",
    "data-name": "Path 141",
    d: "M119.457,334.466S99.77,333.9,80.314,318.657c0,0,6.991,24.359,37.834,24.3Z",
    transform: "translate(-80.314 -318.657)",
    fill: "#8a4a43"
  })))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_595",
    "data-name": "Group 595",
    transform: "translate(104.509 84.63)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_594",
    "data-name": "Group 594"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_593",
    "data-name": "Group 593"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_592",
    "data-name": "Group 592"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_591",
    "data-name": "Group 591"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_590",
    "data-name": "Group 590"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_589",
    "data-name": "Group 589"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_588",
    "data-name": "Group 588"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_587",
    "data-name": "Group 587"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_586",
    "data-name": "Group 586"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_585",
    "data-name": "Group 585"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_584",
    "data-name": "Group 584"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_142",
    "data-name": "Path 142",
    d: "M115.259,291.253a4.448,4.448,0,0,1-4.613,4.178,4.283,4.283,0,0,1-4.164-4.488,4.447,4.447,0,0,1,4.607-4.182A4.289,4.289,0,0,1,115.259,291.253Z",
    transform: "translate(-106.476 -286.758)",
    fill: "#263238"
  }))))))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_608",
    "data-name": "Group 608",
    transform: "translate(100.049 69.066)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_607",
    "data-name": "Group 607"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_606",
    "data-name": "Group 606"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_605",
    "data-name": "Group 605"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_604",
    "data-name": "Group 604"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_603",
    "data-name": "Group 603"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_602",
    "data-name": "Group 602"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_601",
    "data-name": "Group 601"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_600",
    "data-name": "Group 600"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_599",
    "data-name": "Group 599"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_598",
    "data-name": "Group 598"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_597",
    "data-name": "Group 597"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_596",
    "data-name": "Group 596"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_143",
    "data-name": "Path 143",
    d: "M121.626,285.119c-.593.541-3.693-2.3-8.408-2.714-4.7-.487-8.375,1.7-8.834,1.061-.228-.289.415-1.3,2.018-2.3a11.74,11.74,0,0,1,7.135-1.578,11.412,11.412,0,0,1,6.63,2.9C121.517,283.768,121.916,284.88,121.626,285.119Z",
    transform: "translate(-104.34 -279.538)",
    fill: "#263238"
  })))))))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_620",
    "data-name": "Group 620",
    transform: "translate(60.985 82.434)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_619",
    "data-name": "Group 619"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_618",
    "data-name": "Group 618"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_617",
    "data-name": "Group 617"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_616",
    "data-name": "Group 616"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_615",
    "data-name": "Group 615"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_614",
    "data-name": "Group 614"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_613",
    "data-name": "Group 613"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_612",
    "data-name": "Group 612"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_611",
    "data-name": "Group 611"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_610",
    "data-name": "Group 610"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_609",
    "data-name": "Group 609"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_144",
    "data-name": "Path 144",
    d: "M94.41,290.236a4.449,4.449,0,0,1-4.613,4.176,4.284,4.284,0,0,1-4.166-4.488,4.455,4.455,0,0,1,4.609-4.182A4.288,4.288,0,0,1,94.41,290.236Z",
    transform: "translate(-85.625 -285.739)",
    fill: "#263238"
  }))))))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_633",
    "data-name": "Group 633",
    transform: "translate(53.65 65.749)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_632",
    "data-name": "Group 632"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_631",
    "data-name": "Group 631"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_630",
    "data-name": "Group 630"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_629",
    "data-name": "Group 629"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_628",
    "data-name": "Group 628"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_627",
    "data-name": "Group 627"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_626",
    "data-name": "Group 626"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_625",
    "data-name": "Group 625"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_624",
    "data-name": "Group 624"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_623",
    "data-name": "Group 623"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_622",
    "data-name": "Group 622"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_621",
    "data-name": "Group 621"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_145",
    "data-name": "Path 145",
    d: "M99.4,283.582c-.595.541-3.7-2.3-8.41-2.714-4.7-.485-8.375,1.7-8.834,1.061-.23-.287.409-1.3,2.018-2.3a11.754,11.754,0,0,1,7.135-1.58,11.427,11.427,0,0,1,6.63,2.9C99.286,282.23,99.688,283.343,99.4,283.582Z",
    transform: "translate(-82.111 -278)",
    fill: "#263238"
  })))))))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_645",
    "data-name": "Group 645",
    transform: "translate(84.954 68.237)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_644",
    "data-name": "Group 644"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_643",
    "data-name": "Group 643"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_642",
    "data-name": "Group 642"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_641",
    "data-name": "Group 641"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_640",
    "data-name": "Group 640"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_639",
    "data-name": "Group 639"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_638",
    "data-name": "Group 638"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_637",
    "data-name": "Group 637"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_636",
    "data-name": "Group 636"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_635",
    "data-name": "Group 635"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_634",
    "data-name": "Group 634"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_146",
    "data-name": "Path 146",
    d: "M97.108,319.9c0-.28,2.977-.535,7.775-.729,1.215-.019,2.375-.162,2.651-.992.359-.871-.029-2.257-.488-3.758q-1.312-4.663-2.749-9.788c-3.791-13.924-6.421-25.329-5.876-25.482s4.058,11.01,7.846,24.934q1.359,5.145,2.595,9.831c.334,1.453.981,3.126.209,4.935a3.046,3.046,0,0,1-2.133,1.636,7.971,7.971,0,0,1-2.069.108C100.068,320.428,97.1,320.178,97.108,319.9Z",
    transform: "translate(-97.108 -279.153)",
    fill: "#263238"
  }))))))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_657",
    "data-name": "Group 657",
    transform: "translate(69.774 111.085)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_656",
    "data-name": "Group 656"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_655",
    "data-name": "Group 655"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_654",
    "data-name": "Group 654"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_653",
    "data-name": "Group 653"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_652",
    "data-name": "Group 652"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_651",
    "data-name": "Group 651"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_650",
    "data-name": "Group 650"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_649",
    "data-name": "Group 649"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_648",
    "data-name": "Group 648"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_647",
    "data-name": "Group 647"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_646",
    "data-name": "Group 646"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_147",
    "data-name": "Path 147",
    d: "M90.861,299.031c.77.024.328,5.305,4.386,9.455s9.552,4.064,9.529,4.805c.044.339-1.3.916-3.609.772a12.61,12.61,0,0,1-7.98-3.715,11.7,11.7,0,0,1-3.35-7.9C89.83,300.223,90.512,298.967,90.861,299.031Z",
    transform: "translate(-89.836 -299.029)",
    fill: "#263238"
  }))))))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_665",
    "data-name": "Group 665",
    transform: "translate(52.094 47.816)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_664",
    "data-name": "Group 664"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_663",
    "data-name": "Group 663"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_662",
    "data-name": "Group 662"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_661",
    "data-name": "Group 661"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_660",
    "data-name": "Group 660"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_659",
    "data-name": "Group 659"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_658",
    "data-name": "Group 658"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_148",
    "data-name": "Path 148",
    d: "M103.058,274.234c-.578,1.283-5.229.226-10.817.41-5.592.069-10.193,1.334-10.825.08-.278-.6.605-1.772,2.517-2.889a18.291,18.291,0,0,1,16.488-.371C102.378,272.492,103.311,273.626,103.058,274.234Z",
    transform: "translate(-81.366 -269.681)",
    fill: "#263238"
  }))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_673",
    "data-name": "Group 673",
    transform: "translate(100.835 54.567)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_672",
    "data-name": "Group 672"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_671",
    "data-name": "Group 671"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_670",
    "data-name": "Group 670"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_669",
    "data-name": "Group 669"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_668",
    "data-name": "Group 668"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_667",
    "data-name": "Group 667"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_666",
    "data-name": "Group 666"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_149",
    "data-name": "Path 149",
    d: "M120.688,278.652c-.923,1.028-4.07-.414-7.97-.823-3.885-.552-7.272.084-7.934-1.141-.286-.593.33-1.654,1.862-2.568a10.8,10.8,0,0,1,6.642-1.22,10.939,10.939,0,0,1,6.174,2.8C120.744,276.966,121.1,278.145,120.688,278.652Z",
    transform: "translate(-104.716 -272.812)",
    fill: "#263238"
  }))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_680",
    "data-name": "Group 680",
    transform: "translate(0 81.923)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_679",
    "data-name": "Group 679"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_678",
    "data-name": "Group 678"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_677",
    "data-name": "Group 677"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_676",
    "data-name": "Group 676"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_675",
    "data-name": "Group 675"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_674",
    "data-name": "Group 674"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_150",
    "data-name": "Path 150",
    d: "M77.819,294.606a8.515,8.515,0,0,0-8.279-9.1c-5.765.041-12.418,2.813-13.084,15.054-1.181,21.711,20.17,18.458,20.239,17.837C76.744,317.973,77.4,303.7,77.819,294.606Z",
    transform: "translate(-56.409 -285.502)",
    fill: "#b56760"
  })))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_687",
    "data-name": "Group 687",
    transform: "translate(7.195 88.968)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_686",
    "data-name": "Group 686"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_685",
    "data-name": "Group 685"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_684",
    "data-name": "Group 684"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_683",
    "data-name": "Group 683"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_682",
    "data-name": "Group 682"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_681",
    "data-name": "Group 681"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_151",
    "data-name": "Path 151",
    d: "M68.819,306.181c-.088-.073-.382.246-1.017.5a3.562,3.562,0,0,1-2.741-.1c-2.175-.97-3.847-4.721-3.736-8.641a12.815,12.815,0,0,1,1.321-5.355c.729-1.552,1.783-2.6,2.912-2.744a1.859,1.859,0,0,1,2.1,1.162c.25.625.094,1.05.2,1.093.056.058.47-.336.351-1.244a2.448,2.448,0,0,0-.754-1.408,2.712,2.712,0,0,0-2-.67c-1.628.022-3.171,1.477-4.008,3.143a13.172,13.172,0,0,0-1.6,5.978c-.1,4.385,1.841,8.6,4.832,9.688a3.828,3.828,0,0,0,3.379-.379C68.752,306.7,68.89,306.226,68.819,306.181Z",
    transform: "translate(-59.856 -288.77)",
    fill: "#8a4a43"
  }))))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_732",
    "data-name": "Group 732",
    transform: "translate(5.589)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_695",
    "data-name": "Group 695"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_694",
    "data-name": "Group 694"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_693",
    "data-name": "Group 693"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_692",
    "data-name": "Group 692"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_691",
    "data-name": "Group 691"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_152",
    "data-name": "Path 152",
    d: "M61.761,324.629c.747,6.407-1.47,16.468,4.05,15.975,10.944-.977,4.928,20.858,10.316,19.525,5.314-1.317,10.708-6.916,13.169-20.556,3.127-17.318-1.676-31.005,8.082-49.8,5.7-7.246,14.468-11.357,23.418-10.078a26.421,26.421,0,0,1,20.415,15.957c1.9-5.907,6.193-14.576,11.886-16.621s12.622-.53,16.5,4.234,3.908,12.631-.417,16.969a5.85,5.85,0,0,0,7-1.347,10.644,10.644,0,0,1-3.855,7.373,9.3,9.3,0,0,0,5.939-2.945l-2.749,7.269c8.825,1.729,18.891-5.685,22.592-13.159,5.609-11.331,4.626-23.874-.173-35.595s-15.207-21.157-27.386-23.08-23.3,2.322-29.814,13.125c-6.986-7.093-22.663-11.769-32.116-9.113A29.266,29.266,0,0,0,88.786,263.3c-5.127-3.326-12.03-2.565-17.281.552q-.654.388-1.284.819c-7.314,5-11.368,13.793-11.124,22.85.1,3.592.7,7.39.946,10.3C60.782,306.464,61.761,324.629,61.761,324.629Z",
    transform: "translate(-59.087 -238.296)",
    fill: "#263238"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_701",
    "data-name": "Group 701",
    transform: "translate(82.369 26.392)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_700",
    "data-name": "Group 700"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_699",
    "data-name": "Group 699"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_698",
    "data-name": "Group 698"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_697",
    "data-name": "Group 697"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_696",
    "data-name": "Group 696"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_153",
    "data-name": "Path 153",
    d: "M134.736,284.4a3.3,3.3,0,0,0,.8-.459,12.721,12.721,0,0,0,2.052-1.682,18.7,18.7,0,0,0,4.9-8.511,18.088,18.088,0,0,0-1.977-14.392,18.287,18.287,0,0,0-14.841-8.815,20.231,20.231,0,0,0-8.921,1.99,27.791,27.791,0,0,0-7.093,4.8,34.912,34.912,0,0,0-10.942,21.459c-.1,1.168-.173,2.074-.161,2.693a3.478,3.478,0,0,0,.042.94c.25.069-.073-5.336,3.279-12.918A34.388,34.388,0,0,1,110.213,258c3.916-3.538,9.36-6.6,15.434-6.5a17.635,17.635,0,0,1,16.2,22.074A19.107,19.107,0,0,1,137.33,282C135.767,283.651,134.677,284.318,134.736,284.4Z",
    transform: "translate(-98.547 -250.538)",
    fill: "#455a64"
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_707",
    "data-name": "Group 707",
    transform: "translate(79.693 20.214)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_706",
    "data-name": "Group 706"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_705",
    "data-name": "Group 705"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_704",
    "data-name": "Group 704"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_703",
    "data-name": "Group 703"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_702",
    "data-name": "Group 702"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_154",
    "data-name": "Path 154",
    d: "M138.686,297.961a6.077,6.077,0,0,0,.789-.938c.493-.636,1.211-1.578,2.108-2.816a67.576,67.576,0,0,0,6.74-11.109,35.318,35.318,0,0,0,2.753-8.645,25.977,25.977,0,0,0-.2-10.46,20.167,20.167,0,0,0-5.73-9.917,23.317,23.317,0,0,0-10.648-5.732,27.768,27.768,0,0,0-12.011-.028,36.627,36.627,0,0,0-10.479,4.034c-6.27,3.555-10.842,8.746-12.938,13.927a22.437,22.437,0,0,0-1.407,12.954,18.045,18.045,0,0,0,1.054,3.408,5.978,5.978,0,0,0,.576,1.1,29.747,29.747,0,0,1-1.275-4.575,22.63,22.63,0,0,1,1.651-12.612c2.112-4.991,6.6-9.99,12.75-13.424,6.078-3.408,13.977-5.678,21.872-3.846a22.562,22.562,0,0,1,10.239,5.489,19.347,19.347,0,0,1,5.517,9.443,25.335,25.335,0,0,1,.271,10.109,35.279,35.279,0,0,1-2.59,8.5,74.9,74.9,0,0,1-6.44,11.176c-.808,1.2-1.459,2.171-1.962,2.919A5.857,5.857,0,0,0,138.686,297.961Z",
    transform: "translate(-97.266 -247.672)",
    fill: "#455a64"
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_713",
    "data-name": "Group 713",
    transform: "translate(3.094 32.075)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_712",
    "data-name": "Group 712"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_711",
    "data-name": "Group 711"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_710",
    "data-name": "Group 710"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_709",
    "data-name": "Group 709"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_708",
    "data-name": "Group 708"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_155",
    "data-name": "Path 155",
    d: "M69.628,294.823c.129-.121-1.657-1.923-3.688-5.435a32.659,32.659,0,0,1-1.292-30.464c1.728-3.682,3.354-5.64,3.215-5.747a5.852,5.852,0,0,0-1.2,1.315,26.7,26.7,0,0,0-2.6,4.126,31.438,31.438,0,0,0,1.319,31.128,26.363,26.363,0,0,0,2.941,3.874A5.745,5.745,0,0,0,69.628,294.823Z",
    transform: "translate(-60.569 -253.174)",
    fill: "#455a64"
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_719",
    "data-name": "Group 719",
    transform: "translate(14.401 38.564)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_718",
    "data-name": "Group 718"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_717",
    "data-name": "Group 717"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_716",
    "data-name": "Group 716"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_715",
    "data-name": "Group 715"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_714",
    "data-name": "Group 714"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_156",
    "data-name": "Path 156",
    d: "M82.693,293.887c.052-.086-.96-.649-2.417-2.08a15.831,15.831,0,0,1-4.2-7.371l-.551-2.188-.157,2.262c-.209,3.053-.453,6.571-.716,10.385l.741-.3a28.274,28.274,0,0,1-5.692-7.977,28.829,28.829,0,0,1-2.858-12.038,29.671,29.671,0,0,1,1.636-10.038c1.95-5.521,4.5-8.235,4.315-8.352-.025-.022-.186.136-.474.457a18.081,18.081,0,0,0-1.177,1.479,27.108,27.108,0,0,0-3.279,6.179,28.689,28.689,0,0,0,1.006,22.74,28.524,28.524,0,0,0,5.922,8.216l.689.658.052-.964c.2-3.816.39-7.338.553-10.4l-.706.073A15.448,15.448,0,0,0,80,292.117a12.835,12.835,0,0,0,1.931,1.416A2.342,2.342,0,0,0,82.693,293.887Z",
    transform: "translate(-65.986 -256.184)",
    fill: "#455a64"
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_725",
    "data-name": "Group 725",
    transform: "translate(43.921 23.59)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_724",
    "data-name": "Group 724"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_723",
    "data-name": "Group 723"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_722",
    "data-name": "Group 722"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_721",
    "data-name": "Group 721"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_720",
    "data-name": "Group 720"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_157",
    "data-name": "Path 157",
    d: "M80.134,257.846c.161.162,1.543-2.869,5.763-5.37a17.366,17.366,0,0,1,8.011-2.33,18.331,18.331,0,0,1,9.821,2.6,22.083,22.083,0,0,1,7.433,7.224,27.259,27.259,0,0,1,3.359,7.977c1.161,4.868.862,8.046,1.056,8.037a8.088,8.088,0,0,0,.192-2.2,28.052,28.052,0,0,0-.61-6,26.457,26.457,0,0,0-3.281-8.3,22.327,22.327,0,0,0-7.692-7.578,18.7,18.7,0,0,0-10.316-2.65,17.455,17.455,0,0,0-8.306,2.628,15.776,15.776,0,0,0-4.356,4.04,10.687,10.687,0,0,0-.856,1.386C80.182,257.648,80.107,257.829,80.134,257.846Z",
    transform: "translate(-80.128 -249.238)",
    fill: "#455a64"
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_731",
    "data-name": "Group 731",
    transform: "translate(51.332 14.579)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_730",
    "data-name": "Group 730"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_729",
    "data-name": "Group 729"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_728",
    "data-name": "Group 728"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_727",
    "data-name": "Group 727"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_726",
    "data-name": "Group 726"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_158",
    "data-name": "Path 158",
    d: "M83.679,247.164c.067.2,2.236-1.059,6.068-1.317a20.515,20.515,0,0,1,13.889,4.454,27.1,27.1,0,0,1,8.372,12.5c1.25,3.758,1.451,6.256,1.622,6.23a5.781,5.781,0,0,0-.052-1.755,27,27,0,0,0-.948-4.685,26.152,26.152,0,0,0-8.427-13.045,20.2,20.2,0,0,0-14.511-4.372,15.555,15.555,0,0,0-4.517,1.156A5.037,5.037,0,0,0,83.679,247.164Z",
    transform: "translate(-83.679 -245.058)",
    fill: "#455a64"
  }))))))))), /*#__PURE__*/React.createElement("path", {
    id: "Path_159",
    "data-name": "Path 159",
    d: "M74.149,339.892S53.73,359.305,46.809,388.01C38,424.562,70.342,601,70.342,601l170.72-.254-36.606-139.59s-42.349-85.33-42.965-87.238-2.069-20.138-2.069-20.138L81.294,320.6Z",
    transform: "translate(-45.287 -143.172)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_735",
    "data-name": "Group 735",
    transform: "translate(292.774 362.379)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_160",
    "data-name": "Path 160",
    d: "M289.46,429.356c-1.632-3.71-13.365-10.671-13.365-10.671-.979-3.71-6.828-7.231-6.828-7.231a22.131,22.131,0,0,0-7.513-4.721c-4.571-1.686-45.584,3.363-45.584,3.363l-30.624,2.2,1.745,41.655c0,1.013,28.741-10.794,28.741-10.794s12.084,3.038,22.861,5.06,31.586-5.961,31.586-5.961l7.974,7.977c1.511,2.2,2.471,7.856,2.471,11.228s4.131,6.448,6.744,4.088.77-14.065.77-14.065a4.55,4.55,0,0,0,4.5-.67C295.075,449.22,291.092,433.066,289.46,429.356Z",
    transform: "translate(-185.546 -406.388)",
    fill: "#b56760"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_734",
    "data-name": "Group 734",
    transform: "translate(85.444 24.143)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_161",
    "data-name": "Path 161",
    d: "M226.48,417.8c-.035-.093,1.81-.573,4.628.328a16.735,16.735,0,0,1,8.69,7.235,33.961,33.961,0,0,1,3.97,10.779c.589,2.876.8,4.674.66,4.706-.157.037-.633-1.712-1.4-4.512a40.651,40.651,0,0,0-4.141-10.37,17.509,17.509,0,0,0-8.028-7.091C228.275,417.837,226.476,418.009,226.48,417.8Z",
    transform: "translate(-226.48 -417.587)",
    fill: "#8a4a43"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_162",
    "data-name": "Path 162",
    d: "M60.652,381.515s79.011,87.173,109.381,104.224c32.749,18.385,47.114,17.827,47.114,17.827l-5.089-24.081Z",
    transform: "translate(-28.58 -72.758)",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_163",
    "data-name": "Path 163",
    d: "M363.132,483.24l-131.6-16.251S151.791,365.687,131.35,350s-54.7-10.458-65.414,0c-5.588,5.454-8.867,12.963-10.765,20.467a69.618,69.618,0,0,0,2.672,41.549l4.294,11.355c2.336,1.811,126.451,117.241,158.574,119.655s144.923-6.935,144.923-6.935Z",
    transform: "translate(-36.718 -120.622)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_736",
    "data-name": "Group 736",
    transform: "translate(28.862 196.711)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_164",
    "data-name": "Path 164",
    d: "M146.456,363.572a23.082,23.082,0,0,1-3.561-.933c-2.273-.677-5.544-1.727-9.539-3.156-8.007-2.811-18.914-7.138-30.872-12.109S79.719,337.849,71.845,334.7L62.51,331a23.448,23.448,0,0,1-3.4-1.447,23,23,0,0,1,3.536,1.035c2.254.737,5.494,1.873,9.464,3.372,7.955,2.962,18.816,7.4,30.774,12.375s22.8,9.406,30.726,12.4c3.956,1.522,7.181,2.684,9.408,3.488A22.952,22.952,0,0,1,146.456,363.572Z",
    transform: "translate(-59.114 -329.542)",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_738",
    "data-name": "Group 738",
    transform: "translate(14.067 217.546)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_737",
    "data-name": "Group 737"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_165",
    "data-name": "Path 165",
    d: "M119.544,342.819c-.031.1-1.447-.356-4.043-.981a59.921,59.921,0,0,0-11.145-1.677,55.126,55.126,0,0,0-16.545,1.518,49.6,49.6,0,0,0-9.243,3.363,48.945,48.945,0,0,0-8.94,5.724,40.375,40.375,0,0,0-12.472,16.264,57.686,57.686,0,0,0-4.06,16.626A113.383,113.383,0,0,0,52.55,395.3c0,1.274.008,2.322.013,3.178a4.438,4.438,0,0,1-.069,1.115,4.193,4.193,0,0,1-.15-1.1c-.058-.854-.129-1.906-.217-3.18a91.612,91.612,0,0,1,.207-11.732,56.473,56.473,0,0,1,3.905-16.958,40.825,40.825,0,0,1,12.727-16.74,46.566,46.566,0,0,1,18.613-9.2,53.873,53.873,0,0,1,16.831-1.3,53.11,53.11,0,0,1,11.2,2.044c1.3.347,2.275.739,2.943.974A4.078,4.078,0,0,1,119.544,342.819Z",
    transform: "translate(-52.026 -339.206)",
    fill: "#263238"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_739",
    "data-name": "Group 739",
    transform: "translate(25.418 229.381)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_166",
    "data-name": "Path 166",
    d: "M126.677,344.7s.743.58,2.146,1.768c.7.6,1.584,1.322,2.6,2.229l3.377,3.3c5.1,5.012,12.255,12.722,21.087,22.847,17.7,20.22,42.286,49.944,71.324,86.548l-.294-.17,131.645,16.865.449.056.021.466c.8,16.731,1.628,34.28,2.476,52.154l.027.545-.526.041c-1.277.106-2.666.218-4.054.33-23.318,1.854-46.1,3.449-68.115,4.747-11.011.614-21.826,1.214-32.43,1.6s-20.989.729-31.135.556c-2.536.019-5.06-.168-7.567-.267-.628-.039-1.25-.039-1.879-.11l-1.885-.317a20.893,20.893,0,0,1-3.655-.953,76.674,76.674,0,0,1-13.395-6.181A263.233,263.233,0,0,1,173.2,515.416c-14.829-10.6-28.113-21.224-40.119-31.057-23.965-19.739-42.762-36.46-55.7-48.067-6.415-5.834-11.4-10.37-14.808-13.47q-2.5-2.309-3.822-3.536c-.858-.8-1.29-1.22-1.29-1.22s.482.36,1.363,1.134q1.349,1.2,3.893,3.454c3.44,3.061,8.469,7.543,14.941,13.308,13.015,11.5,31.883,28.127,55.894,47.773,12.03,9.785,25.332,20.362,40.155,30.912a262.485,262.485,0,0,0,23.633,15.231,75.78,75.78,0,0,0,13.23,6.084c4.6,1.632,9.673,1.4,14.714,1.58,10.109.16,20.488-.187,31.079-.593s21.4-1,32.409-1.625c22.007-1.313,44.783-2.917,68.092-4.771l4.049-.328-.5.589c-.843-17.874-1.672-35.425-2.461-52.154l.47.522L226.8,462.146l-.182-.024-.115-.144c-28.952-36.656-53.431-66.462-71.008-86.779-8.771-10.173-15.86-17.934-20.888-23l-3.329-3.348q-1.506-1.348-2.545-2.274C127.364,345.354,126.677,344.7,126.677,344.7Z",
    transform: "translate(-57.464 -344.696)",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_740",
    "data-name": "Group 740",
    transform: "translate(188.484 346.729)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_167",
    "data-name": "Path 167",
    d: "M135.667,420.953c-.278-.026.09-5.208,1.881-11.312,1.766-6.114,4.223-10.646,4.471-10.51.288.142-1.7,4.82-3.432,10.833C136.828,415.964,135.985,421,135.667,420.953Z",
    transform: "translate(-135.584 -399.129)",
    fill: "#263238"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_168",
    "data-name": "Path 168",
    d: "M45.9,351.834h0a14.693,14.693,0,0,0-14.451,14.925V565.074h28.9V366.759A14.7,14.7,0,0,0,45.9,351.834Z",
    transform: "translate(-31.448 -107.065)",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Desk",
    transform: "translate(294.077 771.952)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_772",
    "data-name": "Group 772",
    transform: "translate(489.909 50.151)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_769",
    "data-name": "Group 769",
    transform: "translate(0.009)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_169",
    "data-name": "Path 169",
    d: "M497.581,395.029H398.728l27.046,89.216H528.45Z",
    transform: "translate(-369.596 -394.468)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_170",
    "data-name": "Path 170",
    d: "M413.9,395.029c-1.781,1.186-29.131,89.217-29.131,89.217h58.561Z",
    transform: "translate(-384.772 -394.469)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_742",
    "data-name": "Group 742",
    transform: "translate(28.42)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_171",
    "data-name": "Path 171",
    d: "M528.821,484.546a1.847,1.847,0,0,1-.19-.414c-.125-.328-.282-.739-.476-1.25q-.639-1.756-1.776-4.879l-6.515-18.385c-5.527-15.826-13.3-38.085-22.391-64.112l.48.349-49.183.037-49.671-.037.482-.694c8.523,26.094,15.81,48.4,20.989,64.255,2.526,7.858,4.538,14.114,5.941,18.478q.986,3.156,1.543,4.933c.152.522.278.942.376,1.276a1.8,1.8,0,0,1,.1.444,1.768,1.768,0,0,1-.182-.414l-.457-1.25q-.611-1.756-1.695-4.876c-1.467-4.342-3.574-10.564-6.216-18.381-5.271-15.824-12.687-38.085-21.36-64.125l-.232-.694h.712l49.671-.037,49.183.034h.359l.121.349c8.938,26.081,16.584,48.388,22.02,64.246,2.655,7.862,4.768,14.123,6.241,18.488q1.039,3.159,1.622,4.935c.163.524.294.944.4,1.281A1.752,1.752,0,0,1,528.821,484.546Z",
    transform: "translate(-398.387 -394.769)",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_743",
    "data-name": "Group 743",
    transform: "translate(49.856 0.56)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_172",
    "data-name": "Path 172",
    d: "M438.1,484.246c-.284.1-7.1-19.793-15.229-44.425s-14.484-44.69-14.2-44.792,7.1,19.788,15.23,44.43S438.38,484.145,438.1,484.246Z",
    transform: "translate(-408.657 -395.029)",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_744",
    "data-name": "Group 744",
    transform: "translate(70.59 0.56)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_173",
    "data-name": "Path 173",
    d: "M448.029,484.246c-.286.1-7.1-19.793-15.23-44.425s-14.484-44.69-14.2-44.792,7.1,19.788,15.229,44.43S448.313,484.145,448.029,484.246Z",
    transform: "translate(-418.59 -395.029)",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_745",
    "data-name": "Group 745",
    transform: "translate(91.324 0.56)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_174",
    "data-name": "Path 174",
    d: "M457.96,484.246c-.284.1-7.1-19.793-15.227-44.425s-14.486-44.69-14.2-44.792,7.1,19.788,15.229,44.43S458.243,484.145,457.96,484.246Z",
    transform: "translate(-428.523 -395.029)",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_746",
    "data-name": "Group 746",
    transform: "translate(112.056 0.56)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_175",
    "data-name": "Path 175",
    d: "M467.894,484.246c-.284.1-7.1-19.793-15.23-44.425s-14.484-44.69-14.2-44.792,7.1,19.788,15.229,44.43S468.178,484.145,467.894,484.246Z",
    transform: "translate(-438.455 -395.029)",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_747",
    "data-name": "Group 747",
    transform: "translate(37.068 8.988)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_176",
    "data-name": "Path 176",
    d: "M415.363,399.5c0,.311-2.872.563-6.417.563s-6.417-.252-6.417-.563,2.872-.56,6.417-.56S415.363,399.19,415.363,399.5Z",
    transform: "translate(-402.53 -398.938)",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_748",
    "data-name": "Group 748",
    transform: "translate(57.148 8.988)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_177",
    "data-name": "Path 177",
    d: "M424.983,399.5c0,.311-2.872.563-6.417.563s-6.417-.252-6.417-.563,2.872-.56,6.417-.56S424.983,399.19,424.983,399.5Z",
    transform: "translate(-412.15 -398.938)",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_749",
    "data-name": "Group 749",
    transform: "translate(77.037 8.988)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_178",
    "data-name": "Path 178",
    d: "M434.511,399.5c0,.311-2.874.563-6.416.563s-6.417-.252-6.417-.563,2.872-.56,6.417-.56S434.511,399.19,434.511,399.5Z",
    transform: "translate(-421.678 -398.938)",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_750",
    "data-name": "Group 750",
    transform: "translate(117.236 8.988)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_179",
    "data-name": "Path 179",
    d: "M450.676,399.5c0,.311-2.179.563-4.87.563s-4.87-.252-4.87-.563,2.179-.56,4.87-.56S450.676,399.19,450.676,399.5Z",
    transform: "translate(-440.936 -398.938)",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_751",
    "data-name": "Group 751",
    transform: "translate(98.374 8.988)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_180",
    "data-name": "Path 180",
    d: "M444.733,399.5c0,.311-2.872.563-6.417.563s-6.417-.252-6.417-.563,2.872-.56,6.417-.56S444.733,399.19,444.733,399.5Z",
    transform: "translate(-431.9 -398.938)",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_752",
    "data-name": "Group 752",
    transform: "translate(34.183 15.382)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_181",
    "data-name": "Path 181",
    d: "M499.148,402.465c0,.31-21.94.563-49,.563s-49-.252-49-.563,21.934-.561,49-.561S499.148,402.156,499.148,402.465Z",
    transform: "translate(-401.148 -401.904)",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_753",
    "data-name": "Group 753",
    transform: "translate(38.418 27.401)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_182",
    "data-name": "Path 182",
    d: "M501.177,408.04c0,.31-21.94.563-49,.563s-49-.252-49-.563,21.934-.561,49-.561S501.177,407.731,501.177,408.04Z",
    transform: "translate(-403.177 -407.479)",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_754",
    "data-name": "Group 754",
    transform: "translate(42.198 40.859)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_183",
    "data-name": "Path 183",
    d: "M502.988,414.285c0,.31-21.94.561-49,.561s-49-.25-49-.561,21.936-.563,49-.563S502.988,413.974,502.988,414.285Z",
    transform: "translate(-404.988 -413.722)",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_755",
    "data-name": "Group 755",
    transform: "translate(47.168 54.32)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_184",
    "data-name": "Path 184",
    d: "M505.369,420.526c0,.31-21.94.56-49,.56s-49-.25-49-.56,21.936-.56,49-.56S505.369,420.216,505.369,420.526Z",
    transform: "translate(-407.369 -419.966)",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_756",
    "data-name": "Group 756",
    transform: "translate(51.028 67.779)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_185",
    "data-name": "Path 185",
    d: "M507.218,426.77c0,.31-21.94.563-49,.563s-49-.252-49-.563,21.936-.561,49-.561S507.218,426.461,507.218,426.77Z",
    transform: "translate(-409.218 -426.209)",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_757",
    "data-name": "Group 757",
    transform: "translate(81.557 37.473)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_186",
    "data-name": "Path 186",
    d: "M435.394,412.778a2.67,2.67,0,0,1,.889-.093c.582-.021,1.44-.039,2.549-.013a22.092,22.092,0,0,1,9.224,1.914,12.419,12.419,0,0,1,4.96,4.5,8.86,8.86,0,0,1,.994,7.737,10.534,10.534,0,0,1-6.049,5.976,16.312,16.312,0,0,1-8.953.548,30.149,30.149,0,0,1-8.489-2.846,12.633,12.633,0,0,1-5.878-6.151,8.728,8.728,0,0,1,.246-7.8,9.058,9.058,0,0,1,5.392-3.949,12.554,12.554,0,0,1,5.421-.278,23.291,23.291,0,0,1,3.947.983c1.056.354,1.858.671,2.4.895a2.723,2.723,0,0,1,.8.4,27.161,27.161,0,0,1-3.321-.875c-2.083-.5-5.329-1.483-9.032-.364a8.342,8.342,0,0,0-4.834,3.667,7.764,7.764,0,0,0-.1,6.909,11.636,11.636,0,0,0,5.454,5.59,29.672,29.672,0,0,0,8.182,2.714,15.434,15.434,0,0,0,8.381-.468,9.545,9.545,0,0,0,5.5-5.314,7.9,7.9,0,0,0-.818-6.879,11.79,11.79,0,0,0-4.54-4.281,23.384,23.384,0,0,0-8.9-2.19A24.557,24.557,0,0,1,435.394,412.778Z",
    transform: "translate(-423.844 -412.151)",
    fill: "#ff725e"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_758",
    "data-name": "Group 758",
    transform: "translate(84.366 33.914)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_187",
    "data-name": "Path 187",
    d: "M425.195,436.171c-.1-.116,1.259-1.6,3.511-3.926,2.542-2.609,5.532-5.672,8.834-9.059s6.285-6.463,8.823-9.076c2.269-2.313,3.709-3.712,3.82-3.6s-1.133,1.694-3.263,4.152-5.158,5.773-8.615,9.324-6.682,6.655-9.072,8.841S425.293,436.283,425.195,436.171Z",
    transform: "translate(-425.189 -410.5)",
    fill: "#ff725e"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_759",
    "data-name": "Group 759",
    transform: "translate(82.211 34.577)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_188",
    "data-name": "Path 188",
    d: "M459.05,435.165c-.081.129-2.108-1.115-5.321-3.234s-7.609-5.112-12.428-8.475-9.151-6.461-12.253-8.748-4.976-3.764-4.889-3.891,2.119,1.123,5.329,3.24,7.606,5.109,12.42,8.47,9.138,6.452,12.24,8.74S459.129,435.033,459.05,435.165Z",
    transform: "translate(-424.157 -410.808)",
    fill: "#ff725e"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_760",
    "data-name": "Group 760",
    transform: "translate(80.484 19.717)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_189",
    "data-name": "Path 189",
    d: "M434.291,404.655c.027.3-2.446.774-5.525.606s-5.494-.893-5.436-1.188c.056-.315,2.5-.086,5.492.067S434.266,404.336,434.291,404.655Z",
    transform: "translate(-423.329 -403.915)",
    fill: "#ff725e"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_761",
    "data-name": "Group 761",
    transform: "translate(83.668 23.109)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_190",
    "data-name": "Path 190",
    d: "M432.5,405.843c.021.31-1.676.679-3.787.823s-3.841.013-3.862-.3,1.676-.679,3.789-.824S432.484,405.535,432.5,405.843Z",
    transform: "translate(-424.855 -405.488)",
    fill: "#ff725e"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_762",
    "data-name": "Group 762",
    transform: "translate(103.807 20.681)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_191",
    "data-name": "Path 191",
    d: "M442.406,404.759c.027.306-1.739.72-3.949.724s-3.981-.392-3.954-.7,1.791-.414,3.949-.423S442.379,404.446,442.406,404.759Z",
    transform: "translate(-434.503 -404.362)",
    fill: "#ff725e"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_763",
    "data-name": "Group 763",
    transform: "translate(129.559 32.04)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_192",
    "data-name": "Path 192",
    d: "M452.065,410.028c.023.308-1.129.647-2.572.757s-2.632-.054-2.653-.362,1.129-.649,2.574-.757S452.044,409.717,452.065,410.028Z",
    transform: "translate(-446.84 -409.631)",
    fill: "#ff725e"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_764",
    "data-name": "Group 764",
    transform: "translate(66.714 34.445)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_193",
    "data-name": "Path 193",
    d: "M426.294,411.2c.04.3-2.106.834-4.8.757s-4.811-.716-4.757-1.013c.054-.313,2.181-.175,4.786-.11S426.256,410.885,426.294,411.2Z",
    transform: "translate(-416.733 -410.747)",
    fill: "#ff725e"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_765",
    "data-name": "Group 765",
    transform: "translate(51.548 49.153)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_194",
    "data-name": "Path 194",
    d: "M417.242,417.966c.015.311-1.714.649-3.862.759s-3.9-.054-3.914-.364,1.714-.649,3.862-.757S417.228,417.655,417.242,417.966Z",
    transform: "translate(-409.467 -417.569)",
    fill: "#ff725e"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_766",
    "data-name": "Group 766",
    transform: "translate(83.035 76.856)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_195",
    "data-name": "Path 195",
    d: "M432.328,430.621c.048.306-1.653.849-3.8,1.212s-3.926.412-3.974.106,1.651-.849,3.8-1.214S432.278,430.315,432.328,430.621Z",
    transform: "translate(-424.551 -430.419)",
    fill: "#ff725e"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_767",
    "data-name": "Group 767",
    transform: "translate(97.307 63.768)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_196",
    "data-name": "Path 196",
    d: "M442.35,424.835c.027.3-2.434.763-5.5.69s-5.5-.638-5.463-.94,2.486-.248,5.488-.183S442.327,424.52,442.35,424.835Z",
    transform: "translate(-431.389 -424.348)",
    fill: "#ff725e"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_768",
    "data-name": "Group 768",
    transform: "translate(121.782 61.567)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_197",
    "data-name": "Path 197",
    d: "M451.4,423.687c.017.308-1.822.675-4.11.817s-4.158.009-4.177-.3,1.822-.675,4.11-.817S451.382,423.376,451.4,423.687Z",
    transform: "translate(-443.114 -423.327)",
    fill: "#ff725e"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_770",
    "data-name": "Group 770",
    transform: "translate(0 0.56)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_198",
    "data-name": "Path 198",
    d: "M413.908,395.029c.286.1-6.005,20.153-14.05,44.785s-14.8,44.531-15.081,44.432,6.005-20.148,14.052-44.79S413.624,394.93,413.908,395.029Z",
    transform: "translate(-384.767 -395.029)",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_771",
    "data-name": "Group 771",
    transform: "translate(57.055 80.723)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_199",
    "data-name": "Path 199",
    d: "M510.1,432.773c0,.311-21.938.561-49,.561s-49-.25-49-.561,21.936-.56,49-.56S510.1,432.463,510.1,432.773Z",
    transform: "translate(-412.101 -432.213)",
    fill: "#263238"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_774",
    "data-name": "Group 774",
    transform: "translate(114.333)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_200",
    "data-name": "Path 200",
    d: "M377.93,371.845l-1-.22a3.924,3.924,0,0,0-4.651,3.091L344.916,503.276H209.023a3.986,3.986,0,0,0-3.92,4.049h0a3.987,3.987,0,0,0,3.92,4.051H351.474L380.933,376.7A4.055,4.055,0,0,0,377.93,371.845Z",
    transform: "translate(-204.555 -371.472)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_773",
    "data-name": "Group 773"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_201",
    "data-name": "Path 201",
    d: "M378.215,371.881a3.465,3.465,0,0,1,2.217,1.289,4.2,4.2,0,0,1,.969,3.076c-.2,1.3-.553,2.734-.889,4.4-1.424,6.646-3.5,16.33-6.135,28.649-5.354,24.7-12.992,59.936-22.16,102.223l-.081.377h-.376l-142.7.065a4.517,4.517,0,0,1-4.108-3.617,4.691,4.691,0,0,1,2.256-5.047,5.034,5.034,0,0,1,2.707-.543h7.548l19.855,0,38.316.017,69.57.06-.453.375c8.769-40.8,16.058-74.719,21.164-98.474,2.574-11.831,4.6-21.123,5.985-27.5.407-1.546.472-3.074,1.28-4.1a3.99,3.99,0,0,1,2.6-1.578,4.228,4.228,0,0,1,1.841.16c.4.1.6.172.6.172s-.211-.021-.616-.1a4.391,4.391,0,0,0-1.8-.084,3.851,3.851,0,0,0-2.448,1.563c-.739.959-.789,2.464-1.175,4.034-1.33,6.39-3.269,15.7-5.736,27.556-5.014,23.777-12.172,57.724-20.784,98.56l-.079.375H345.2l-69.57.063-38.316.015q-9.822,0-19.855,0l-5.026,0h-2.522a3.939,3.939,0,0,0-2.2.412,3.545,3.545,0,0,0-1.705,3.818,3.415,3.415,0,0,0,3.106,2.736l142.643.088-.457.377c9.324-42.25,17.094-77.455,22.542-102.135,2.745-12.292,4.9-21.955,6.385-28.588.357-1.645.737-3.113.954-4.353a4.067,4.067,0,0,0-.862-2.958A4.29,4.29,0,0,0,378.215,371.881Z",
    transform: "translate(-204.84 -371.506)",
    fill: "#263238"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_776",
    "data-name": "Group 776",
    transform: "translate(0 139.523)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_52",
    "data-name": "Rectangle 52",
    width: 969.71,
    height: 30.305,
    transform: "translate(0.543 0.561)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_775",
    "data-name": "Group 775"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_202",
    "data-name": "Path 202",
    d: "M1120.32,467.092c0-.89-.042-9.772-.125-30.307l.125.132c-102.146.045-497.692.22-969.663.431h-.048l.543-.563v30.3l-.543-.56c538.542.313,963.816.558,969.711.563-5.89,0-431.169.248-969.711.56h-.543V436.225h.591l969.663.431h.125v.129C1120.36,457.32,1120.325,466.2,1120.32,467.092Z",
    transform: "translate(-150.067 -436.225)",
    fill: "#263238"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_783",
    "data-name": "Group 783",
    transform: "translate(639.899 110.18)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_778",
    "data-name": "Group 778",
    transform: "translate(18.423 10.418)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_53",
    "data-name": "Rectangle 53",
    width: 200.752,
    height: 18.613,
    transform: "translate(0.544 0.561)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_777",
    "data-name": "Group 777"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_203",
    "data-name": "Path 203",
    d: "M666.745,446.62s-.027-.44-.042-1.257l-.05-3.6c-.029-3.182-.071-7.8-.123-13.754l.215.224c-33.45.2-110.756.339-200.741.339h-.01l.543-.563c0,6.377,0,12.691,0,18.613l-.541-.558,142.393.237,42.687.166,11.591.078,3.027.039c.684.013,1.054.039,1.054.039s-.319.026-.981.039l-2.956.039c-2.661.017-6.515.045-11.466.078-10.055.039-24.562.1-42.562.166l-142.787.239h-.543v-.561c0-5.922,0-12.236,0-18.613l.545-.56H466c89.985,0,167.291.14,200.741.338l.217,0,0,.22c-.052,6.006-.094,10.671-.121,13.881-.023,1.531-.04,2.712-.052,3.555C666.772,446.236,666.745,446.62,666.745,446.62Z",
    transform: "translate(-465.449 -427.446)",
    fill: "#263238"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_780",
    "data-name": "Group 780"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_54",
    "data-name": "Rectangle 54",
    width: 198.434,
    height: 10.366,
    transform: "translate(0.544 0.613)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_779",
    "data-name": "Group 779"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_204",
    "data-name": "Path 204",
    d: "M655.6,433.592a6.532,6.532,0,0,1-.029-.653c-.008-.466-.021-1.093-.038-1.923-.021-1.744-.05-4.31-.092-7.789l.159.164c-25.184.231-104.567.4-198.422.4h-.008c.242-.25-.545.561.541-.56v10.365l-.543-.56c55.2.093,104.722.175,140.493.233l42.351.17,11.524.08,3.014.039c.683.013,1.05.039,1.05.039s-.317.028-.975.041l-2.939.039-11.4.08-42.226.168-140.894.233-.543,0v-.563c0-1.643,0-3.348,0-5.088v-5.277c1.088-1.121.3-.311.547-.561h.008c93.855,0,173.238.166,198.422.4h.163l0,.164c-.042,3.523-.071,6.12-.092,7.884-.017.815-.029,1.429-.038,1.886A3.876,3.876,0,0,1,655.6,433.592Z",
    transform: "translate(-456.623 -422.614)",
    fill: "#263238"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_781",
    "data-name": "Group 781",
    transform: "translate(19.955 22.193)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_205",
    "data-name": "Path 205",
    d: "M660.334,433.469c0,.31-43.465.563-97.072.563-53.623,0-97.08-.252-97.08-.563s43.457-.561,97.08-.561C616.869,432.908,660.334,433.158,660.334,433.469Z",
    transform: "translate(-466.183 -432.908)",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_782",
    "data-name": "Group 782",
    transform: "translate(24.735 17.256)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_206",
    "data-name": "Path 206",
    d: "M662.624,431.178c0,.31-43.466.563-97.071.563-53.623,0-97.08-.252-97.08-.563s43.457-.56,97.08-.56C619.159,430.618,662.624,430.868,662.624,431.178Z",
    transform: "translate(-468.473 -430.618)",
    fill: "#263238"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_792",
    "data-name": "Group 792",
    transform: "translate(381.958 8.554)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_785",
    "data-name": "Group 785",
    transform: "translate(0 7.112)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_217",
    "data-name": "Path 217",
    d: "M0,0,7.046-.017l-.24,105.164-7.046.017Z",
    transform: "matrix(-0.997, 0.072, -0.072, -0.997, 14.35, 104.923)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_207",
    "data-name": "Path 207",
    d: "M334.841,413.29l10.019-.746,2.363,33.875a5.134,5.134,0,0,1-4.646,5.547h0a5.076,5.076,0,0,1-5.371-4.8Z",
    transform: "translate(-331.106 -339.739)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_218",
    "data-name": "Path 218",
    d: "M0,0,1.95,0l-.1,44.065-1.95,0Z",
    transform: "matrix(-0.997, 0.072, -0.072, -0.997, 5.714, 101.888)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_784",
    "data-name": "Group 784",
    transform: "translate(3.092 72.716)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_208",
    "data-name": "Path 208",
    d: "M345.2,412.592c.019.224-4.1.821-10.092,1.5l.445-.543c.182,2.365.378,4.928.584,7.632.349,5.006.605,9.544.735,12.831s.138,5.327-.013,5.338-.426-2.009-.754-5.282-.7-7.8-1.054-12.806c-.171-2.706-.332-5.273-.482-7.64l-.031-.5.476-.039C341.016,412.579,345.174,412.368,345.2,412.592Z",
    transform: "translate(-334.533 -412.503)",
    fill: "#263238"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_787",
    "data-name": "Group 787",
    transform: "translate(12.866 3.007)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_57",
    "data-name": "Rectangle 57",
    width: 7.045,
    height: 82.115,
    transform: "translate(1.643 7.071)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_209",
    "data-name": "Path 209",
    d: "M349.259,416.019H339.215V382.056a5.107,5.107,0,0,1,5.022-5.187h0a5.106,5.106,0,0,1,5.022,5.187Z",
    transform: "translate(-339.215 -376.869)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_58",
    "data-name": "Rectangle 58",
    width: 1.95,
    height: 44.072,
    transform: "translate(10.046 10.738)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_786",
    "data-name": "Group 786",
    transform: "translate(0 13.084)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_210",
    "data-name": "Path 210",
    d: "M339.215,409c0-.224,4.148-.515,10.172-.744l-.482.507c-.017-2.371-.033-4.943-.05-7.655,0-5.019.06-9.563.159-12.851s.234-5.323.384-5.323.286,2.033.384,5.323.159,7.832.159,12.851c-.017,2.712-.033,5.284-.05,7.655l0,.507-.478,0C343.381,409.328,339.221,409.231,339.215,409Z",
    transform: "translate(-339.215 -382.938)",
    fill: "#263238"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_789",
    "data-name": "Group 789",
    transform: "translate(27.064 22.278)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_59",
    "data-name": "Rectangle 59",
    width: 7.045,
    height: 82.115,
    transform: "translate(1.641 7.07)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_211",
    "data-name": "Path 211",
    d: "M356.061,424.958H346.017V390.995a5.106,5.106,0,0,1,5.022-5.187h0a5.107,5.107,0,0,1,5.022,5.187Z",
    transform: "translate(-346.017 -385.808)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_60",
    "data-name": "Rectangle 60",
    width: 1.95,
    height: 44.072,
    transform: "translate(10.044 10.738)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_788",
    "data-name": "Group 788",
    transform: "translate(0 13.082)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_212",
    "data-name": "Path 212",
    d: "M346.017,417.944c-.006-.226,4.148-.515,10.17-.746l-.482.509c-.015-2.374-.033-4.943-.05-7.655,0-5.019.06-9.563.159-12.853s.234-5.323.384-5.323.286,2.035.384,5.323.161,7.834.161,12.853c-.019,2.712-.036,5.282-.052,7.655l0,.5-.48,0C350.181,418.268,346.021,418.168,346.017,417.944Z",
    transform: "translate(-346.017 -391.876)",
    fill: "#263238"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_791",
    "data-name": "Group 791",
    transform: "translate(40.448)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_61",
    "data-name": "Rectangle 61",
    width: 7.045,
    height: 82.115,
    transform: "translate(1.642 7.07)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_213",
    "data-name": "Path 213",
    d: "M362.473,414.624H352.429V380.661a5.106,5.106,0,0,1,5.022-5.187h0a5.106,5.106,0,0,1,5.022,5.187Z",
    transform: "translate(-352.429 -375.474)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_62",
    "data-name": "Rectangle 62",
    width: 1.949,
    height: 44.072,
    transform: "translate(10.045 10.737)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_790",
    "data-name": "Group 790",
    transform: "translate(0 13.082)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_214",
    "data-name": "Path 214",
    d: "M352.429,407.61c0-.226,4.148-.517,10.17-.746l-.48.509c-.017-2.374-.033-4.945-.052-7.655,0-5.021.061-9.563.161-12.853s.234-5.323.384-5.323.286,2.035.384,5.323.159,7.832.159,12.853c-.019,2.71-.035,5.282-.05,7.655l0,.5-.478,0C356.6,407.932,352.435,407.835,352.429,407.61Z",
    transform: "translate(-352.429 -381.542)",
    fill: "#263238"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_215",
    "data-name": "Path 215",
    d: "M384.373,472.943H339.208l-5.941-68.135h57.574Z",
    transform: "translate(-332.817 -341.569)",
    fill: "#ff725e"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeroImg);
export default __webpack_public_path__ + "static/media/hero-img.3ac60bb65520b892e7c82ece5763122a.svg";
export { ForwardRef as ReactComponent };